import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, Input, HostBinding, Output, HostListener, inject, PLATFORM_ID, Injectable, NgModule } from '@angular/core';
import * as i1$1 from '@angular/common';
import { DOCUMENT, isPlatformBrowser, CommonModule } from '@angular/common';
import * as i1 from '@angular/router';
import { NavigationEnd, RouterModule } from '@angular/router';
import { filter, BehaviorSubject } from 'rxjs';
import * as i2 from 'angular-svg-icon';
import { AngularSvgIconModule } from 'angular-svg-icon';
import * as i3 from '@devop/ngx-metronic/popper';
import { PopperPlacements, PopperTriggers, PopperModule } from '@devop/ngx-metronic/popper';
import * as i1$2 from '@angular/forms';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { updateTheme } from '@devop/ngx-metronic/layout-polyfill';
function MenuItemComponent_a_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
const _c0 = a0 => ({
  $implicit: a0
});
function MenuItemComponent_a_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 4);
    i0.ɵɵlistener("click", function MenuItemComponent_a_0_Template_a_click_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r6 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r6.onItemClick($event, ctx_r6.item));
    });
    i0.ɵɵtemplate(1, MenuItemComponent_a_0_ng_container_1_Template, 1, 0, "ng-container", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r4 = i0.ɵɵreference(4);
    i0.ɵɵclassProp("active", !ctx_r0.item.children && ctx_r0.isActive());
    i0.ɵɵproperty("routerLink", ctx_r0.item.link);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", _r4)("ngTemplateOutletContext", i0.ɵɵpureFunction1(5, _c0, ctx_r0.item));
  }
}
function MenuItemComponent_span_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function MenuItemComponent_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtemplate(1, MenuItemComponent_span_1_ng_container_1_Template, 1, 0, "ng-container", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const _r4 = i0.ɵɵreference(4);
    i0.ɵɵclassProp("active", !ctx_r1.item.children && ctx_r1.isActive());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", _r4)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c0, ctx_r1.item));
  }
}
function MenuItemComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "met-sub-menu", 7);
    i0.ɵɵlistener("itemClick", function MenuItemComponent_ng_container_2_Template_met_sub_menu_itemClick_1_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r9 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r9.itemClick.next($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("show", ctx_r2.show)("item", ctx_r2.item);
  }
}
function MenuItemComponent_ng_template_3_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵelement(1, "span", 13);
    i0.ɵɵelementEnd();
  }
}
function MenuItemComponent_ng_template_3_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵelement(1, "svg-icon", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r11 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", item_r11.svg);
  }
}
function MenuItemComponent_ng_template_3_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 16);
  }
}
function MenuItemComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MenuItemComponent_ng_template_3_span_0_Template, 2, 0, "span", 8)(1, MenuItemComponent_ng_template_3_span_1_Template, 2, 1, "span", 9);
    i0.ɵɵelementStart(2, "span", 10);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, MenuItemComponent_ng_template_3_span_4_Template, 1, 0, "span", 11);
  }
  if (rf & 2) {
    const item_r11 = ctx.$implicit;
    i0.ɵɵproperty("ngIf", !item_r11.svg);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r11.svg);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r11.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r11.children == null ? null : item_r11.children.length);
  }
}
function SubMenuComponent_met_menu_item_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "met-menu-item", 1);
    i0.ɵɵlistener("itemClick", function SubMenuComponent_met_menu_item_0_Template_met_menu_item_itemClick_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.itemClick.next($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    i0.ɵɵproperty("item", item_r1);
  }
}
function SideMenuComponent_met_menu_item_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "met-menu-item", 3);
    i0.ɵɵlistener("itemClick", function SideMenuComponent_met_menu_item_2_Template_met_menu_item_itemClick_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.itemClick.next($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const menu_r1 = ctx.$implicit;
    i0.ɵɵproperty("item", menu_r1);
  }
}
const _c1 = ["*"];
function TopMenuComponent_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
const _c2 = a0 => ({
  menu: a0,
  depth: 0
});
function TopMenuComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TopMenuComponent_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const m_r5 = ctx.$implicit;
    i0.ɵɵnextContext();
    const _r2 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", _r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c2, m_r5));
  }
}
function TopMenuComponent_ng_template_2_a_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
const _c3 = (a0, a1) => ({
  menu: a0,
  depth: a1
});
function TopMenuComponent_ng_template_2_a_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 11);
    i0.ɵɵtemplate(1, TopMenuComponent_ng_template_2_a_1_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext();
    const menu_r7 = ctx_r15.menu;
    const depth_r8 = ctx_r15.depth;
    const ctx_r9 = i0.ɵɵnextContext();
    const _r4 = i0.ɵɵreference(5);
    let tmp_2_0;
    i0.ɵɵproperty("target", menu_r7.target)("routerLink", menu_r7.link)("routerLinkActiveOptions", (tmp_2_0 = menu_r7.activeOptions) !== null && tmp_2_0 !== undefined ? tmp_2_0 : ctx_r9.defaultActiveOptions);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", _r4)("ngTemplateOutletContext", i0.ɵɵpureFunction2(5, _c3, menu_r7, depth_r8));
  }
}
function TopMenuComponent_ng_template_2_a_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TopMenuComponent_ng_template_2_a_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 12);
    i0.ɵɵtemplate(1, TopMenuComponent_ng_template_2_a_2_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext();
    const menu_r7 = ctx_r17.menu;
    const depth_r8 = ctx_r17.depth;
    i0.ɵɵnextContext();
    const _r4 = i0.ɵɵreference(5);
    i0.ɵɵproperty("href", menu_r7.href, i0.ɵɵsanitizeUrl)("target", menu_r7.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", _r4)("ngTemplateOutletContext", i0.ɵɵpureFunction2(4, _c3, menu_r7, depth_r8));
  }
}
function TopMenuComponent_ng_template_2_a_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TopMenuComponent_ng_template_2_a_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 13);
    i0.ɵɵtemplate(1, TopMenuComponent_ng_template_2_a_3_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext();
    const menu_r7 = ctx_r19.menu;
    const depth_r8 = ctx_r19.depth;
    const _r12 = i0.ɵɵreference(5);
    const ctx_r11 = i0.ɵɵnextContext();
    const _r4 = i0.ɵɵreference(5);
    i0.ɵɵproperty("metPopper", _r12)("metPopperDisabled", !menu_r7.children)("metPopperTrigger", ctx_r11.trigger.hover)("metPopperTimeout", 100)("metPopperHideOnMouseLeave", true)("metPopperHideOnClickOutside", true)("metPopperHideOnScroll", true)("metPopperPlacement", depth_r8 === 0 ? ctx_r11.placement.BOTTOMSTART : ctx_r11.placement.RIGHTSTART);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", _r4)("ngTemplateOutletContext", i0.ɵɵpureFunction2(10, _c3, menu_r7, depth_r8));
  }
}
function TopMenuComponent_ng_template_2_ng_container_7_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TopMenuComponent_ng_template_2_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TopMenuComponent_ng_template_2_ng_container_7_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const m_r20 = ctx.$implicit;
    const depth_r8 = i0.ɵɵnextContext().depth;
    i0.ɵɵnextContext();
    const _r2 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", _r2)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c3, m_r20, depth_r8 + 1));
  }
}
const _c4 = () => ["menu-here-bg", "here"];
function TopMenuComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, TopMenuComponent_ng_template_2_a_1_Template, 2, 8, "a", 6)(2, TopMenuComponent_ng_template_2_a_2_Template, 2, 7, "a", 7)(3, TopMenuComponent_ng_template_2_a_3_Template, 2, 13, "a", 8);
    i0.ɵɵelementStart(4, "met-popper-content", null, 9)(6, "div", 10);
    i0.ɵɵtemplate(7, TopMenuComponent_ng_template_2_ng_container_7_Template, 2, 5, "ng-container", 1);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const menu_r7 = ctx.menu;
    const ctx_r1 = i0.ɵɵnextContext();
    let tmp_1_0;
    i0.ɵɵproperty("routerLinkActive", i0.ɵɵpureFunction0(6, _c4))("routerLinkActiveOptions", (tmp_1_0 = menu_r7.activeOptions) !== null && tmp_1_0 !== undefined ? tmp_1_0 : ctx_r1.defaultActiveOptions);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", menu_r7.link);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", menu_r7.href);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !menu_r7.href && !menu_r7.link);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", menu_r7.children);
  }
}
function TopMenuComponent_ng_template_4_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵelement(1, "span", 19);
    i0.ɵɵelementEnd();
  }
}
function TopMenuComponent_ng_template_4_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 20);
    i0.ɵɵelement(1, "svg-icon", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const menu_r23 = i0.ɵɵnextContext().menu;
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", menu_r23.svg);
  }
}
function TopMenuComponent_ng_template_4_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 22);
  }
}
function TopMenuComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TopMenuComponent_ng_template_4_span_0_Template, 2, 0, "span", 14)(1, TopMenuComponent_ng_template_4_span_1_Template, 2, 1, "span", 15);
    i0.ɵɵelementStart(2, "span", 16);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, TopMenuComponent_ng_template_4_span_4_Template, 1, 0, "span", 17);
  }
  if (rf & 2) {
    const menu_r23 = ctx.menu;
    const depth_r24 = ctx.depth;
    i0.ɵɵproperty("ngIf", depth_r24 > 0 && !menu_r23.svg);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", depth_r24 > 0 && menu_r23.svg);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(menu_r23.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", depth_r24 > 0 && menu_r23.children);
  }
}
function SearchToolComponent_div_5_met_search_tool_results_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "met-search-tool-results");
  }
}
function SearchToolComponent_div_5_met_search_tool_recent_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "met-search-tool-recent");
  }
}
function SearchToolComponent_div_5_met_search_tool_empty_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "met-search-tool-empty");
  }
}
function SearchToolComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "form", 7);
    i0.ɵɵelement(2, "svg-icon", 8)(3, "input", 9);
    i0.ɵɵelementStart(4, "span", 10);
    i0.ɵɵelement(5, "span", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 12);
    i0.ɵɵelement(7, "svg-icon", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 14)(9, "div", 15);
    i0.ɵɵlistener("click", function SearchToolComponent_div_5_Template_div_click_9_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r7 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r7.view = "settings");
    });
    i0.ɵɵelement(10, "svg-icon", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 17);
    i0.ɵɵlistener("click", function SearchToolComponent_div_5_Template_div_click_11_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r9 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r9.view = "advanced");
    });
    i0.ɵɵelement(12, "svg-icon", 18);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelement(13, "div", 19);
    i0.ɵɵtemplate(14, SearchToolComponent_div_5_met_search_tool_results_14_Template, 1, 0, "met-search-tool-results", 4)(15, SearchToolComponent_div_5_met_search_tool_recent_15_Template, 1, 0, "met-search-tool-recent", 4)(16, SearchToolComponent_div_5_met_search_tool_empty_16_Template, 1, 0, "met-search-tool-empty", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(14);
    i0.ɵɵproperty("ngIf", ctx_r1.searchView === "results");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.searchView === "recent");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.searchView === "empty");
  }
}
function SearchToolComponent_met_search_tool_settings_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "met-search-tool-settings", 20);
    i0.ɵɵlistener("cancel", function SearchToolComponent_met_search_tool_settings_6_Template_met_search_tool_settings_cancel_0_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r10 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r10.view = "search");
    })("save", function SearchToolComponent_met_search_tool_settings_6_Template_met_search_tool_settings_save_0_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r12 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r12.onSaveSettings());
    });
    i0.ɵɵelementEnd();
  }
}
function SearchToolComponent_met_search_tool_advanced_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "met-search-tool-advanced", 21);
    i0.ɵɵlistener("cancel", function SearchToolComponent_met_search_tool_advanced_7_Template_met_search_tool_advanced_cancel_0_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r13 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r13.view = "search");
    })("search", function SearchToolComponent_met_search_tool_advanced_7_Template_met_search_tool_advanced_search_0_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r15 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r15.onAdvancedSearch());
    });
    i0.ɵɵelementEnd();
  }
}
function HeaderNotificationComponent_li_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 14)(1, "a", 15);
    i0.ɵɵlistener("click", function HeaderNotificationComponent_li_14_Template_a_click_1_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r4);
      const tab_r2 = restoredCtx.$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.activeTab = tab_r2);
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const tab_r2 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("active", ctx_r1.activeTab === tab_r2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(tab_r2.title);
  }
}
function HeaderUserComponent_span_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.badge.label);
  }
}
function HeaderUserComponent_div_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "a", 19);
    i0.ɵɵlistener("click", function HeaderUserComponent_div_16_Template_a_click_1_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r5);
      const item_r3 = restoredCtx.$implicit;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.onMenuItemClick(item_r3));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r3.label);
  }
}
function FooterComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "span", 4);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "a", 5);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind2(3, 3, ctx_r0.date, "YYYY"), "\xA9");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("href", ctx_r0.copyright.href, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.copyright.label);
  }
}
function FooterComponent_ul_3_li_1_a_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("href", item_r3.href, i0.ɵɵsanitizeUrl)("target", item_r3.target);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r3.title);
  }
}
function FooterComponent_ul_3_li_1_a_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 12);
    i0.ɵɵlistener("click", function FooterComponent_ul_3_li_1_a_2_Template_a_click_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const item_r3 = i0.ɵɵnextContext().$implicit;
      return i0.ɵɵresetView(item_r3.click && item_r3.click($event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r5 = i0.ɵɵnextContext(2);
    let tmp_2_0;
    i0.ɵɵproperty("target", item_r3.target)("routerLink", item_r3.link)("routerLinkActiveOptions", (tmp_2_0 = item_r3.activeOptions) !== null && tmp_2_0 !== undefined ? tmp_2_0 : ctx_r5.defaultActiveOptions);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r3.title, " ");
  }
}
function FooterComponent_ul_3_li_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 8);
    i0.ɵɵtemplate(1, FooterComponent_ul_3_li_1_a_1_Template, 2, 3, "a", 9)(2, FooterComponent_ul_3_li_1_a_2_Template, 2, 4, "a", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r3.href);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r3.link);
  }
}
function FooterComponent_ul_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 6);
    i0.ɵɵtemplate(1, FooterComponent_ul_3_li_1_Template, 3, 2, "li", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.menu);
  }
}
const _c5 = [[["", "title", ""]], [["", "subtitle", ""]], [["", "tools", ""]], "*"];
const _c6 = ["[title]", "[subtitle]", "[tools]", "*"];
let MenuItemComponent = /*#__PURE__*/(() => {
  class MenuItemComponent {
    constructor(router, cdr) {
      this.router = router;
      this.class = 'menu-item menu-accordion';
      this.show = false;
      this.itemClick = new EventEmitter();
      this.sub = this.router.events.pipe(filter(evt => evt instanceof NavigationEnd)).subscribe(() => {
        this.show = this.show && this.item.children && this.item.children?.length > 0 || this.isActive();
        cdr.detectChanges();
      });
    }
    ngOnInit() {
      this.show = this.isActive();
    }
    ngOnDestroy() {
      this.sub?.unsubscribe();
    }
    onClick(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      this.show = !this.show;
    }
    onItemClick($event, item) {
      this.itemClick.next({
        event: $event,
        item
      });
    }
    isActive() {
      return this.isItemActive(this.item);
    }
    isItemActive(item) {
      if (item.link) {
        return this.router.isActive(item.link, {
          paths: isExact(item.activeOptions) ? 'exact' : 'subset',
          queryParams: 'ignored',
          fragment: 'ignored',
          matrixParams: 'ignored'
        });
      }
      return !!(item.children && item.children.find(this.isItemActive.bind(this)));
    }
    static {
      this.ɵfac = function MenuItemComponent_Factory(t) {
        return new (t || MenuItemComponent)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MenuItemComponent,
        selectors: [["met-menu-item"]],
        hostVars: 4,
        hostBindings: function MenuItemComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function MenuItemComponent_click_HostBindingHandler($event) {
              return ctx.onClick($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.class);
            i0.ɵɵclassProp("show", ctx.show);
          }
        },
        inputs: {
          item: "item"
        },
        outputs: {
          itemClick: "itemClick"
        },
        decls: 5,
        vars: 3,
        consts: [["class", "menu-link", 3, "routerLink", "active", "click", 4, "ngIf"], ["class", "menu-link", 3, "active", 4, "ngIf"], [4, "ngIf"], ["itemContent", ""], [1, "menu-link", 3, "routerLink", "click"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "menu-link"], [3, "show", "item", "itemClick"], ["class", "menu-bullet", 4, "ngIf"], ["class", "menu-icon", 4, "ngIf"], [1, "menu-title"], ["class", "menu-arrow", 4, "ngIf"], [1, "menu-bullet"], [1, "bullet", "bullet-dot"], [1, "menu-icon"], [1, "svg-icon", "svg-icon-2", 3, "src"], [1, "menu-arrow"]],
        template: function MenuItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, MenuItemComponent_a_0_Template, 2, 7, "a", 0)(1, MenuItemComponent_span_1_Template, 2, 6, "span", 1)(2, MenuItemComponent_ng_container_2_Template, 2, 2, "ng-container", 2)(3, MenuItemComponent_ng_template_3_Template, 5, 4, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.item.link);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.item.link);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.item.children);
          }
        },
        dependencies: () => [i1$1.NgIf, i1$1.NgTemplateOutlet, i2.SvgIconComponent, i1.RouterLink, SubMenuComponent],
        changeDetection: 0
      });
    }
  }
  return MenuItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function isExact(options) {
  return options && options['exact'];
}
let SubMenuComponent = /*#__PURE__*/(() => {
  class SubMenuComponent {
    set show(value) {
      this._show = value;
      if (!value) {
        this.anim = true;
      }
      if (this.elm) {
        this.updateHeight();
      }
    }
    get children() {
      return this.item?.children ?? [];
    }
    constructor(elm, cdr) {
      this.elm = elm;
      this.cdr = cdr;
      this.itemClick = new EventEmitter();
      this.class = 'menu-sub menu-sub-accordion';
      this.anim = false;
      this.height = '1000px';
      this.heightChange = new EventEmitter();
      this._show = false;
      this.lastHeight = 0;
      this.offsetHeight = 0;
    }
    ngAfterViewInit() {
      if (this._show) {
        setTimeout(() => this.updateHeight());
        setTimeout(() => this.anim = true, 1000);
      }
    }
    ngOnDestroy() {
      this.sub?.unsubscribe();
    }
    updateHeight() {
      const height = this._show ? this.elm.nativeElement.scrollHeight + this.offsetHeight : 0;
      const diff = height - this.lastHeight;
      if (diff !== 0) {
        this.heightChange.emit(height - this.lastHeight);
      }
      this.height = height + 'px';
      this.lastHeight = height;
      this.cdr.markForCheck();
    }
    static {
      this.ɵfac = function SubMenuComponent_Factory(t) {
        return new (t || SubMenuComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SubMenuComponent,
        selectors: [["met-sub-menu"]],
        hostVars: 6,
        hostBindings: function SubMenuComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.class);
            i0.ɵɵstyleProp("max-height", ctx.height);
            i0.ɵɵclassProp("anim", ctx.anim);
          }
        },
        inputs: {
          item: "item",
          show: "show"
        },
        outputs: {
          itemClick: "itemClick",
          heightChange: "heightChange"
        },
        decls: 1,
        vars: 1,
        consts: [[3, "item", "itemClick", 4, "ngFor", "ngForOf"], [3, "item", "itemClick"]],
        template: function SubMenuComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, SubMenuComponent_met_menu_item_0_Template, 1, 1, "met-menu-item", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngForOf", ctx.children);
          }
        },
        dependencies: [i1$1.NgForOf, MenuItemComponent],
        styles: ["[_nghost-%COMP%]{display:block;overflow:hidden;max-height:0}.anim[_nghost-%COMP%]{transition:max-height .5s}"]
      });
    }
  }
  return SubMenuComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SideMenuComponent = /*#__PURE__*/(() => {
  class SideMenuComponent {
    constructor() {
      this.menu = [];
      this.itemClick = new EventEmitter();
    }
    static {
      this.ɵfac = function SideMenuComponent_Factory(t) {
        return new (t || SideMenuComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SideMenuComponent,
        selectors: [["met-side-menu"]],
        inputs: {
          menu: "menu"
        },
        outputs: {
          itemClick: "itemClick"
        },
        decls: 3,
        vars: 1,
        consts: [[1, "app-sidebar-wrapper", "hover-scroll-overlay-y", "scroll-thin", "my-5"], [1, "menu", "menu-column", "menu-rounded", "menu-sub-indention", "px-3"], [3, "item", "itemClick", 4, "ngFor", "ngForOf"], [3, "item", "itemClick"]],
        template: function SideMenuComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, SideMenuComponent_met_menu_item_2_Template, 1, 1, "met-menu-item", 2);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.menu);
          }
        },
        dependencies: [i1$1.NgForOf, MenuItemComponent],
        styles: [".menu-sub-accordion[_ngcontent-%COMP%]{overflow:hidden;max-height:0}.menu-sub-accordion.expand[_ngcontent-%COMP%]{display:block}"]
      });
    }
  }
  return SideMenuComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AsideComponent = /*#__PURE__*/(() => {
  class AsideComponent {
    constructor() {
      this.on = false;
      this.animating = false;
    }
    transitionEnd() {
      this.animating = false;
    }
    static {
      this.ɵfac = function AsideComponent_Factory(t) {
        return new (t || AsideComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AsideComponent,
        selectors: [["met-aside"]],
        hostVars: 4,
        hostBindings: function AsideComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("transitionend", function AsideComponent_transitionend_HostBindingHandler() {
              return ctx.transitionEnd();
            });
          }
          if (rf & 2) {
            i0.ɵɵclassProp("drawer-on", ctx.on)("animating", ctx.animating);
          }
        },
        inputs: {
          on: "on"
        },
        ngContentSelectors: _c1,
        decls: 1,
        vars: 0,
        template: function AsideComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        }
      });
    }
  }
  return AsideComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TopMenuComponent = /*#__PURE__*/(() => {
  class TopMenuComponent {
    constructor() {
      this.placement = PopperPlacements;
      this.trigger = PopperTriggers;
      this.defaultActiveOptions = {
        exact: false
      };
      this.menu = [];
    }
    static {
      this.ɵfac = function TopMenuComponent_Factory(t) {
        return new (t || TopMenuComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TopMenuComponent,
        selectors: [["met-top-menu"]],
        inputs: {
          defaultActiveOptions: "defaultActiveOptions",
          menu: "menu"
        },
        decls: 6,
        vars: 1,
        consts: [[1, "menu", "menu-rounded", "menu-column", "menu-lg-row", "my-5", "my-lg-0", "align-items-stretch", "fw-semibold", "px-2", "px-lg-0"], [4, "ngFor", "ngForOf"], ["menuTemplate", ""], ["menuContent", ""], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "menu-item", "menu-lg-down-accordion", "me-0", "me-lg-2", 3, "routerLinkActive", "routerLinkActiveOptions"], ["class", "menu-link", "routerLinkActive", "here", 3, "target", "routerLink", "routerLinkActiveOptions", 4, "ngIf"], ["class", "menu-link", 3, "href", "target", 4, "ngIf"], ["class", "menu-link", "href", "#", 3, "metPopper", "metPopperDisabled", "metPopperTrigger", "metPopperTimeout", "metPopperHideOnMouseLeave", "metPopperHideOnClickOutside", "metPopperHideOnScroll", "metPopperPlacement", 4, "ngIf"], ["content", ""], [1, "menu-sub", "menu-sub-lg-down-accordion", "menu-sub-lg-dropdown", "menu-active-bg", "px-lg-2", "py-lg-4", "w-lg-225px", 2, "display", "block"], ["routerLinkActive", "here", 1, "menu-link", 3, "target", "routerLink", "routerLinkActiveOptions"], [1, "menu-link", 3, "href", "target"], ["href", "#", 1, "menu-link", 3, "metPopper", "metPopperDisabled", "metPopperTrigger", "metPopperTimeout", "metPopperHideOnMouseLeave", "metPopperHideOnClickOutside", "metPopperHideOnScroll", "metPopperPlacement"], ["class", "menu-bullet", 4, "ngIf"], ["class", "menu-icon", 4, "ngIf"], [1, "menu-title"], ["class", "menu-arrow", 4, "ngIf"], [1, "menu-bullet"], [1, "bullet", "bullet-dot"], [1, "menu-icon"], [1, "svg-icon", "svg-icon-2", 3, "src"], [1, "menu-arrow"]],
        template: function TopMenuComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, TopMenuComponent_ng_container_1_Template, 2, 4, "ng-container", 1);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(2, TopMenuComponent_ng_template_2_Template, 8, 7, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(4, TopMenuComponent_ng_template_4_Template, 5, 4, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.menu);
          }
        },
        dependencies: [i1$1.NgForOf, i1$1.NgIf, i1$1.NgTemplateOutlet, i2.SvgIconComponent, i3.PopperDirective, i3.PopperContentComponent, i1.RouterLink, i1.RouterLinkActive],
        styles: [".ngxp__arrow{display:none}  .ngxp__container{top:-10px!important}"]
      });
    }
  }
  return TopMenuComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SearchToolResultsComponent = /*#__PURE__*/(() => {
  class SearchToolResultsComponent {
    static {
      this.ɵfac = function SearchToolResultsComponent_Factory(t) {
        return new (t || SearchToolResultsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SearchToolResultsComponent,
        selectors: [["met-search-tool-results"]],
        decls: 152,
        vars: 0,
        consts: [[1, "scroll-y", "scroll-thin", "mh-200px", "mh-lg-350px"], [1, "fs-5", "text-muted", "m-0", "pb-5"], ["href", "#", 1, "d-flex", "text-dark", "text-hover-primary", "align-items-center", "mb-5"], [1, "symbol", "symbol-40px", "me-4"], ["src", "assets/media/metronic/avatars/150-1.jpg", "alt", ""], [1, "d-flex", "flex-column", "justify-content-start", "fw-bold"], [1, "fs-6", "fw-bold"], [1, "fs-7", "fw-bold", "text-muted"], ["src", "assets/media/metronic/avatars/150-3.jpg", "alt", ""], ["src", "assets/media/metronic/avatars/150-8.jpg", "alt", ""], ["src", "assets/media/metronic/avatars/150-11.jpg", "alt", ""], ["src", "assets/media/metronic/avatars/150-12.jpg", "alt", ""], [1, "fs-5", "text-muted", "m-0", "pt-5", "pb-5"], [1, "symbol-label", "bg-light"], ["src", "assets/media/metronic/svg/brand-logos/volicity-9.svg", "alt", "", 1, "w-20px", "h-20px"], ["src", "assets/media/metronic/svg/brand-logos/tvit.svg", "alt", "", 1, "w-20px", "h-20px"], ["src", "assets/media/metronic/svg/misc/infography.svg", "alt", "", 1, "w-20px", "h-20px"], ["src", "assets/media/metronic/svg/brand-logos/leaf.svg", "alt", "", 1, "w-20px", "h-20px"], ["src", "assets/media/metronic/svg/brand-logos/tower.svg", "alt", "", 1, "w-20px", "h-20px"], [1, "svg-icon", "svg-icon-2", "svg-icon-primary"], ["xmlns", "http://www.w3.org/2000/svg", "width", "24px", "height", "24px", "viewBox", "0 0 24 24", "version", "1.1"], ["d", "M8,3 L8,3.5 C8,4.32842712 8.67157288,5 9.5,5 L14.5,5 C15.3284271,5 16,4.32842712 16,3.5 L16,3 L18,3 C19.1045695,3 20,3.8954305 20,5 L20,21 C20,22.1045695 19.1045695,23 18,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,5 C4,3.8954305 4.8954305,3 6,3 L8,3 Z", "fill", "#000000", "opacity", "0.3"], ["d", "M11,2 C11,1.44771525 11.4477153,1 12,1 C12.5522847,1 13,1.44771525 13,2 L14.5,2 C14.7761424,2 15,2.22385763 15,2.5 L15,3.5 C15,3.77614237 14.7761424,4 14.5,4 L9.5,4 C9.22385763,4 9,3.77614237 9,3.5 L9,2.5 C9,2.22385763 9.22385763,2 9.5,2 L11,2 Z", "fill", "#000000"], ["fill", "#000000", "opacity", "0.3", "x", "10", "y", "9", "width", "7", "height", "2", "rx", "1"], ["fill", "#000000", "opacity", "0.3", "x", "7", "y", "9", "width", "2", "height", "2", "rx", "1"], ["fill", "#000000", "opacity", "0.3", "x", "7", "y", "13", "width", "2", "height", "2", "rx", "1"], ["fill", "#000000", "opacity", "0.3", "x", "10", "y", "13", "width", "7", "height", "2", "rx", "1"], ["fill", "#000000", "opacity", "0.3", "x", "7", "y", "17", "width", "2", "height", "2", "rx", "1"], ["fill", "#000000", "opacity", "0.3", "x", "10", "y", "17", "width", "7", "height", "2", "rx", "1"], [1, "d-flex", "flex-column"], ["xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "width", "24px", "height", "24px", "viewBox", "0 0 24 24", "version", "1.1"], ["stroke", "none", "stroke-width", "1", "fill", "none", "fill-rule", "evenodd"], ["x", "0", "y", "0", "width", "24", "height", "24"], ["fill", "#000000", "opacity", "0.3", "x", "13", "y", "4", "width", "3", "height", "16", "rx", "1.5"], ["fill", "#000000", "x", "8", "y", "9", "width", "3", "height", "11", "rx", "1.5"], ["fill", "#000000", "x", "18", "y", "11", "width", "3", "height", "9", "rx", "1.5"], ["fill", "#000000", "x", "3", "y", "13", "width", "3", "height", "7", "rx", "1.5"], ["d", "M16,15.6315789 L16,12 C16,10.3431458 14.6568542,9 13,9 L6.16183229,9 L6.16183229,5.52631579 C6.16183229,4.13107011 7.29290239,3 8.68814808,3 L20.4776218,3 C21.8728674,3 23.0039375,4.13107011 23.0039375,5.52631579 L23.0039375,13.1052632 L23.0206157,17.786793 C23.0215995,18.0629336 22.7985408,18.2875874 22.5224001,18.2885711 C22.3891754,18.2890457 22.2612702,18.2363324 22.1670655,18.1421277 L19.6565168,15.6315789 L16,15.6315789 Z", "fill", "#000000"], ["d", "M1.98505595,18 L1.98505595,13 C1.98505595,11.8954305 2.88048645,11 3.98505595,11 L11.9850559,11 C13.0896254,11 13.9850559,11.8954305 13.9850559,13 L13.9850559,18 C13.9850559,19.1045695 13.0896254,20 11.9850559,20 L4.10078614,20 L2.85693427,21.1905292 C2.65744295,21.3814685 2.34093638,21.3745358 2.14999706,21.1750444 C2.06092565,21.0819836 2.01120804,20.958136 2.01120804,20.8293182 L2.01120804,18.32426 C1.99400175,18.2187196 1.98505595,18.1104045 1.98505595,18 Z M6.5,14 C6.22385763,14 6,14.2238576 6,14.5 C6,14.7761424 6.22385763,15 6.5,15 L11.5,15 C11.7761424,15 12,14.7761424 12,14.5 C12,14.2238576 11.7761424,14 11.5,14 L6.5,14 Z M9.5,16 C9.22385763,16 9,16.2238576 9,16.5 C9,16.7761424 9.22385763,17 9.5,17 L11.5,17 C11.7761424,17 12,16.7761424 12,16.5 C12,16.2238576 11.7761424,16 11.5,16 L9.5,16 Z", "fill", "#000000", "opacity", "0.3"], ["points", "0 0 24 0 24 24 0 24"], ["d", "M12,11 C9.790861,11 8,9.209139 8,7 C8,4.790861 9.790861,3 12,3 C14.209139,3 16,4.790861 16,7 C16,9.209139 14.209139,11 12,11 Z", "fill", "#000000", "fill-rule", "nonzero", "opacity", "0.3"], ["d", "M3.00065168,20.1992055 C3.38825852,15.4265159 7.26191235,13 11.9833413,13 C16.7712164,13 20.7048837,15.2931929 20.9979143,20.2 C21.0095879,20.3954741 20.9979143,21 20.2466999,21 C16.541124,21 11.0347247,21 3.72750223,21 C3.47671215,21 2.97953825,20.45918 3.00065168,20.1992055 Z", "fill", "#000000", "fill-rule", "nonzero"]],
        template: function SearchToolResultsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "h3", 1);
            i0.ɵɵtext(2, "Users");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "a", 2)(4, "div", 3);
            i0.ɵɵelement(5, "img", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 5)(7, "span", 6);
            i0.ɵɵtext(8, "Karina Clark");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "span", 7);
            i0.ɵɵtext(10, "Marketing Manager");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(11, "a", 2)(12, "div", 3);
            i0.ɵɵelement(13, "img", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(14, "div", 5)(15, "span", 6);
            i0.ɵɵtext(16, "Olivia Bold");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(17, "span", 7);
            i0.ɵɵtext(18, "Software Engineer");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(19, "a", 2)(20, "div", 3);
            i0.ɵɵelement(21, "img", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(22, "div", 5)(23, "span", 6);
            i0.ɵɵtext(24, "Ana Clark");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(25, "span", 7);
            i0.ɵɵtext(26, "UI/UX Designer");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(27, "a", 2)(28, "div", 3);
            i0.ɵɵelement(29, "img", 10);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(30, "div", 5)(31, "span", 6);
            i0.ɵɵtext(32, "Nick Pitola");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(33, "span", 7);
            i0.ɵɵtext(34, "Art Director");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(35, "a", 2)(36, "div", 3);
            i0.ɵɵelement(37, "img", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(38, "div", 5)(39, "span", 6);
            i0.ɵɵtext(40, "Edward Kulnic");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(41, "span", 7);
            i0.ɵɵtext(42, "System Administrator");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(43, "h3", 12);
            i0.ɵɵtext(44, "Customers");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(45, "a", 2)(46, "div", 3)(47, "span", 13);
            i0.ɵɵelement(48, "img", 14);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(49, "div", 5)(50, "span", 6);
            i0.ɵɵtext(51, "Company Rbranding");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(52, "span", 7);
            i0.ɵɵtext(53, "UI Design");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(54, "a", 2)(55, "div", 3)(56, "span", 13);
            i0.ɵɵelement(57, "img", 15);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(58, "div", 5)(59, "span", 6);
            i0.ɵɵtext(60, "Company Re-branding");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(61, "span", 7);
            i0.ɵɵtext(62, "Web Development");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(63, "a", 2)(64, "div", 3)(65, "span", 13);
            i0.ɵɵelement(66, "img", 16);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(67, "div", 5)(68, "span", 6);
            i0.ɵɵtext(69, "Business Analytics App");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(70, "span", 7);
            i0.ɵɵtext(71, "Administration");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(72, "a", 2)(73, "div", 3)(74, "span", 13);
            i0.ɵɵelement(75, "img", 17);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(76, "div", 5)(77, "span", 6);
            i0.ɵɵtext(78, "EcoLeaf App Launch");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(79, "span", 7);
            i0.ɵɵtext(80, "Marketing");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(81, "a", 2)(82, "div", 3)(83, "span", 13);
            i0.ɵɵelement(84, "img", 18);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(85, "div", 5)(86, "span", 6);
            i0.ɵɵtext(87, "Tower Group Website");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(88, "span", 7);
            i0.ɵɵtext(89, "Google Adwords");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(90, "h3", 12);
            i0.ɵɵtext(91, "Projects");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(92, "a", 2)(93, "div", 3)(94, "span", 13)(95, "span", 19);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(96, "svg", 20);
            i0.ɵɵelement(97, "path", 21)(98, "path", 22)(99, "rect", 23)(100, "rect", 24)(101, "rect", 25)(102, "rect", 26)(103, "rect", 27)(104, "rect", 28);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(105, "div", 29)(106, "span", 6);
            i0.ɵɵtext(107, "Si-Fi Project by AU Themes");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(108, "span", 7);
            i0.ɵɵtext(109, "#45670");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(110, "a", 2)(111, "div", 3)(112, "span", 13)(113, "span", 19);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(114, "svg", 30)(115, "g", 31);
            i0.ɵɵelement(116, "rect", 32)(117, "rect", 33)(118, "rect", 34)(119, "rect", 35)(120, "rect", 36);
            i0.ɵɵelementEnd()()()()();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(121, "div", 29)(122, "span", 6);
            i0.ɵɵtext(123, "Shopix Mobile App Planning");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(124, "span", 7);
            i0.ɵɵtext(125, "#45690");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(126, "a", 2)(127, "div", 3)(128, "span", 13)(129, "span", 19);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(130, "svg", 20);
            i0.ɵɵelement(131, "path", 37)(132, "path", 38);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(133, "div", 29)(134, "span", 6);
            i0.ɵɵtext(135, "Finance Monitoring SAAS Discussion");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(136, "span", 7);
            i0.ɵɵtext(137, "#21090");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(138, "a", 2)(139, "div", 3)(140, "span", 13)(141, "span", 19);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(142, "svg", 30)(143, "g", 31);
            i0.ɵɵelement(144, "polygon", 39)(145, "path", 40)(146, "path", 41);
            i0.ɵɵelementEnd()()()()();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(147, "div", 29)(148, "span", 6);
            i0.ɵɵtext(149, "Dashboard Analitics Launch");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(150, "span", 7);
            i0.ɵɵtext(151, "#34560");
            i0.ɵɵelementEnd()()()();
          }
        }
      });
    }
  }
  return SearchToolResultsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SearchToolRecentComponent = /*#__PURE__*/(() => {
  class SearchToolRecentComponent {
    static {
      this.ɵfac = function SearchToolRecentComponent_Factory(t) {
        return new (t || SearchToolRecentComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SearchToolRecentComponent,
        selectors: [["met-search-tool-recent"]],
        decls: 100,
        vars: 0,
        consts: [[1, "mb-4"], [1, "d-flex", "flex-stack", "fw-bold", "mb-4"], [1, "text-muted", "fs-6", "me-2"], [1, "scroll-y", "scroll-thin", "mh-200px", "mh-lg-325px"], [1, "d-flex", "align-items-center", "mb-5"], [1, "symbol", "symbol-40px", "me-4"], [1, "symbol-label", "bg-light"], [1, "svg-icon", "svg-icon-2", "svg-icon-primary"], ["xmlns", "http://www.w3.org/2000/svg", "width", "24", "height", "24", "viewBox", "0 0 24 24", "fill", "none"], ["opacity", "0.25"], ["d", "M2 15C2 16.6569 3.34315 18 5 18L19 18C20.6569 18 22 16.6569 22 15V5C22 3.34315 20.6569 2 19 2H5C3.34315 2 2 3.34315 2 5V15Z", "fill", "#12131A"], ["d", "M8 20C7.44772 20 7 20.4477 7 21C7 21.5523 7.44772 22 8 22H16C16.5523 22 17 21.5523 17 21C17 20.4477 16.5523 20 16 20H8Z", "fill", "#12131A"], ["d", "M7 6C6.44772 6 6 6.44772 6 7C6 7.55228 6.44772 8 7 8H14C14.5523 8 15 7.55228 15 7C15 6.44772 14.5523 6 14 6H7Z", "fill", "#12131A"], ["d", "M7 10C6.44772 10 6 10.4477 6 11C6 11.5523 6.44772 12 7 12H9C9.55229 12 10 11.5523 10 11C10 10.4477 9.55229 10 9 10H7Z", "fill", "#12131A"], [1, "d-flex", "flex-column"], ["href", "#", 1, "fs-6", "text-gray-800", "text-hover-primary", "fw-bold"], [1, "fs-7", "text-muted", "fw-bold"], ["d", "M20 13C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11C19.4477 11 19 11.4477 19 12C19 12.5523 19.4477 13 20 13Z", "fill", "#12131A"], ["d", "M20 17C20.5523 17 21 16.5523 21 16C21 15.4477 20.5523 15 20 15C19.4477 15 19 15.4477 19 16C19 16.5523 19.4477 17 20 17Z", "fill", "#12131A"], ["d", "M20 21C20.5523 21 21 20.5523 21 20C21 19.4477 20.5523 19 20 19C19.4477 19 19 19.4477 19 20C19 20.5523 19.4477 21 20 21Z", "fill", "#12131A"], ["d", "M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z", "fill", "#12131A"], ["d", "M12 21C12.5523 21 13 20.5523 13 20C13 19.4477 12.5523 19 12 19C11.4477 19 11 19.4477 11 20C11 20.5523 11.4477 21 12 21Z", "fill", "#12131A"], ["d", "M4 21C4.55228 21 5 20.5523 5 20C5 19.4477 4.55228 19 4 19C3.44772 19 3 19.4477 3 20C3 20.5523 3.44772 21 4 21Z", "fill", "#12131A"], ["d", "M17 6C17 7.65685 18.3431 9 20 9C21.6569 9 23 7.65685 23 6C23 4.34315 21.6569 3 20 3C18.3431 3 17 4.34315 17 6Z", "fill", "#12131A"], ["d", "M9 10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10Z", "fill", "#12131A"], ["d", "M4 17C2.34315 17 1 15.6569 1 14C1 12.3431 2.34315 11 4 11C5.65685 11 7 12.3431 7 14C7 15.6569 5.65685 17 4 17Z", "fill", "#12131A"], ["opacity", "0.25", "fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M11 4.25769C11 3.07501 9.9663 2.13515 8.84397 2.50814C4.86766 3.82961 2 7.57987 2 11.9999C2 13.6101 2.38057 15.1314 3.05667 16.4788C3.58731 17.5363 4.98303 17.6028 5.81966 16.7662L5.91302 16.6728C6.60358 15.9823 6.65613 14.9011 6.3341 13.9791C6.11766 13.3594 6 12.6934 6 11.9999C6 9.62064 7.38488 7.56483 9.39252 6.59458C10.2721 6.16952 11 5.36732 11 4.39046V4.25769ZM16.4787 20.9434C17.5362 20.4127 17.6027 19.017 16.7661 18.1804L16.6727 18.087C15.9822 17.3964 14.901 17.3439 13.979 17.6659C13.3594 17.8823 12.6934 17.9999 12 17.9999C11.3066 17.9999 10.6406 17.8823 10.021 17.6659C9.09899 17.3439 8.01784 17.3964 7.3273 18.087L7.23392 18.1804C6.39728 19.017 6.4638 20.4127 7.52133 20.9434C8.86866 21.6194 10.3899 21.9999 12 21.9999C13.6101 21.9999 15.1313 21.6194 16.4787 20.9434Z", "fill", "#12131A"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M13 4.39046C13 5.36732 13.7279 6.16952 14.6075 6.59458C16.6151 7.56483 18 9.62064 18 11.9999C18 12.6934 17.8823 13.3594 17.6659 13.9791C17.3439 14.9011 17.3964 15.9823 18.087 16.6728L18.1803 16.7662C19.017 17.6028 20.4127 17.5363 20.9433 16.4788C21.6194 15.1314 22 13.6101 22 11.9999C22 7.57987 19.1323 3.82961 15.156 2.50814C14.0337 2.13515 13 3.07501 13 4.25769V4.39046Z", "fill", "#12131A"], ["opacity", "0.25", "d", "M2 13.8857C2 13.1875 2.69737 12.7042 3.35112 12.9493L8.14677 14.7477C8.64016 14.9327 9.17357 14.9845 9.69334 14.8979L14.6354 14.0742C14.8087 14.0453 14.9865 14.0626 15.151 14.1243L21.3511 16.4493C21.7414 16.5957 22 16.9688 22 17.3857V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V13.8857Z", "fill", "#12131A"], ["d", "M2 4.13517C2 2.4395 3.97771 1.51318 5.28037 2.59873L8.93565 5.64479C9.1593 5.83117 9.45306 5.91083 9.74023 5.86296L14.0555 5.14376C14.8073 5.01846 15.5786 5.18401 16.2128 5.60679L20.6641 8.57435C21.4987 9.13074 22 10.0674 22 11.0705V13.1138C22 13.812 21.3026 14.2953 20.6489 14.0501L15.8532 12.2518C15.3598 12.0667 14.8264 12.0149 14.3067 12.1016L9.36454 12.9253C9.19129 12.9541 9.01348 12.9369 8.84902 12.8752L2.64888 10.5501C2.25857 10.4038 2 10.0307 2 9.61381V4.13517Z", "fill", "#12131A"], ["opacity", "0.25", "d", "M1 6C1 4.34315 2.34315 3 4 3H20C21.6569 3 23 4.34315 23 6V18C23 19.6569 21.6569 21 20 21H4C2.34315 21 1 19.6569 1 18V6Z", "fill", "#191213"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M5.23177 7.35984C5.58534 6.93556 6.2159 6.87824 6.64018 7.2318L11.3598 11.1648C11.7307 11.4739 12.2693 11.4739 12.6402 11.1648L17.3598 7.2318C17.7841 6.87824 18.4147 6.93556 18.7682 7.35984C19.1218 7.78412 19.0645 8.41468 18.6402 8.76825L13.9205 12.7013C12.808 13.6284 11.192 13.6284 10.0794 12.7013L5.35981 8.76825C4.93553 8.41468 4.87821 7.78412 5.23177 7.35984Z", "fill", "#121319"], ["opacity", "0.25", "d", "M4 10H8V17H10V10H14V17H16V10H20V17C21.1046 17 22 17.8954 22 19V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V19C2 17.8954 2.89543 17 4 17V10Z", "fill", "#12131A"], ["d", "M2 7.35405C2 6.53624 2.4979 5.80083 3.25722 5.4971L11.2572 2.2971C11.734 2.10637 12.266 2.10637 12.7428 2.2971L20.7428 5.4971C21.5021 5.80083 22 6.53624 22 7.35405V7.99999C22 9.10456 21.1046 9.99999 20 9.99999H4C2.89543 9.99999 2 9.10456 2 7.99999V7.35405Z", "fill", "#12131A"], ["opacity", "0.25", "d", "M1 5C1 3.89543 1.89543 3 3 3H21C22.1046 3 23 3.89543 23 5V19C23 20.1046 22.1046 21 21 21H3C1.89543 21 1 20.1046 1 19V5Z", "fill", "#12131A"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M20.8682 6.49631C21.1422 6.01679 20.9756 5.40594 20.4961 5.13193C20.0166 4.85792 19.4058 5.02451 19.1317 5.50403L15.8834 11.1886C15.6612 11.5775 15.2073 11.7712 14.7727 11.6626L9.71238 10.3975C8.40847 10.0715 7.04688 10.6526 6.38005 11.8195L3.13174 17.504C2.85773 17.9835 3.02433 18.5944 3.50385 18.8684C3.98337 19.1424 4.59422 18.9758 4.86823 18.4963L8.11653 12.8118C8.33881 12.4228 8.79268 12.2291 9.22731 12.3378L14.2876 13.6028C15.5915 13.9288 16.9531 13.3478 17.6199 12.1808L20.8682 6.49631Z", "fill", "#12131A"]],
        template: function SearchToolRecentComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "span", 2);
            i0.ɵɵtext(3, "Recently Searched:");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "div", 3)(5, "div", 4)(6, "div", 5)(7, "span", 6)(8, "span", 7);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(9, "svg", 8)(10, "g", 9);
            i0.ɵɵelement(11, "path", 10)(12, "path", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(13, "path", 12)(14, "path", 13);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(15, "div", 14)(16, "a", 15);
            i0.ɵɵtext(17, "BoomApp by Keenthemes");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(18, "span", 16);
            i0.ɵɵtext(19, "#45789");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(20, "div", 4)(21, "div", 5)(22, "span", 6)(23, "span", 7);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(24, "svg", 8)(25, "g", 9);
            i0.ɵɵelement(26, "path", 17)(27, "path", 18)(28, "path", 19)(29, "path", 20)(30, "path", 21)(31, "path", 22);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(32, "path", 23)(33, "path", 24)(34, "path", 25);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(35, "div", 14)(36, "a", 15);
            i0.ɵɵtext(37, "\"Kept API Project Meeting");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(38, "span", 16);
            i0.ɵɵtext(39, "#84050");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(40, "div", 4)(41, "div", 5)(42, "span", 6)(43, "span", 7);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(44, "svg", 8);
            i0.ɵɵelement(45, "path", 26)(46, "path", 27);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(47, "div", 14)(48, "a", 15);
            i0.ɵɵtext(49, "\"KPI Monitoring App Launch");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(50, "span", 16);
            i0.ɵɵtext(51, "#84250");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(52, "div", 4)(53, "div", 5)(54, "span", 6)(55, "span", 7);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(56, "svg", 8);
            i0.ɵɵelement(57, "path", 28)(58, "path", 29);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(59, "div", 14)(60, "a", 15);
            i0.ɵɵtext(61, "Project Reference FAQ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(62, "span", 16);
            i0.ɵɵtext(63, "#67945");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(64, "div", 4)(65, "div", 5)(66, "span", 6)(67, "span", 7);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(68, "svg", 8);
            i0.ɵɵelement(69, "path", 30)(70, "path", 31);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(71, "div", 14)(72, "a", 15);
            i0.ɵɵtext(73, "\"FitPro App Development");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(74, "span", 16);
            i0.ɵɵtext(75, "#84250");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(76, "div", 4)(77, "div", 5)(78, "span", 6)(79, "span", 7);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(80, "svg", 8);
            i0.ɵɵelement(81, "path", 32)(82, "path", 33);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(83, "div", 14)(84, "a", 15);
            i0.ɵɵtext(85, "Shopix Mobile App");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(86, "span", 16);
            i0.ɵɵtext(87, "#45690");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(88, "div", 4)(89, "div", 5)(90, "span", 6)(91, "span", 7);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(92, "svg", 8);
            i0.ɵɵelement(93, "path", 34)(94, "path", 35);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(95, "div", 14)(96, "a", 15);
            i0.ɵɵtext(97, "\"Landing UI Design\" Launch");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(98, "span", 16);
            i0.ɵɵtext(99, "#24005");
            i0.ɵɵelementEnd()()()()();
          }
        }
      });
    }
  }
  return SearchToolRecentComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SearchToolEmptyComponent = /*#__PURE__*/(() => {
  class SearchToolEmptyComponent {
    static {
      this.ɵfac = function SearchToolEmptyComponent_Factory(t) {
        return new (t || SearchToolEmptyComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SearchToolEmptyComponent,
        selectors: [["met-search-tool-empty"]],
        decls: 12,
        vars: 0,
        consts: [[1, "text-center"], [1, "pt-10", "pb-10"], [1, "svg-icon", "svg-icon-4x", "opacity-50"], ["xmlns", "http://www.w3.org/2000/svg", "width", "24", "height", "24", "viewBox", "0 0 24 24", "fill", "none"], ["opacity", "0.25", "d", "M3 4C3 2.34315 4.34315 1 6 1H15.7574C16.553 1 17.3161 1.31607 17.8787 1.87868L20.1213 4.12132C20.6839 4.68393 21 5.44699 21 6.24264V20C21 21.6569 19.6569 23 18 23H6C4.34315 23 3 21.6569 3 20V4Z", "fill", "#12131A"], ["d", "M15 1.89181C15 1.39927 15.3993 1 15.8918 1V1C16.6014 1 17.2819 1.28187 17.7836 1.78361L20.2164 4.21639C20.7181 4.71813 21 5.39863 21 6.10819V6.10819C21 6.60073 20.6007 7 20.1082 7H16C15.4477 7 15 6.55228 15 6V1.89181Z", "fill", "#12131A"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M13.032 15.4462C12.4365 15.7981 11.7418 16 11 16C8.79086 16 7 14.2091 7 12C7 9.79086 8.79086 8 11 8C13.2091 8 15 9.79086 15 12C15 12.7418 14.7981 13.4365 14.4462 14.032L16.7072 16.293C17.0977 16.6835 17.0977 17.3167 16.7072 17.7072C16.3167 18.0977 15.6835 18.0977 15.293 17.7072L13.032 15.4462ZM13 12C13 13.1046 12.1046 14 11 14C9.89543 14 9 13.1046 9 12C9 10.8954 9.89543 10 11 10C12.1046 10 13 10.8954 13 12Z", "fill", "#12131A"], [1, "pb-15", "fw-bold"], [1, "text-gray-600", "fs-5", "mb-2"], [1, "text-muted", "fs-7"]],
        template: function SearchToolEmptyComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "span", 2);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(3, "svg", 3);
            i0.ɵɵelement(4, "path", 4)(5, "path", 5)(6, "path", 6);
            i0.ɵɵelementEnd()()();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(7, "div", 7)(8, "h3", 8);
            i0.ɵɵtext(9, "No result found");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "div", 9);
            i0.ɵɵtext(11, "Please try again with a different query");
            i0.ɵɵelementEnd()()();
          }
        }
      });
    }
  }
  return SearchToolEmptyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SearchToolSettingsComponent = /*#__PURE__*/(() => {
  class SearchToolSettingsComponent {
    constructor() {
      this.cancel = new EventEmitter();
      this.save = new EventEmitter();
    }
    static {
      this.ɵfac = function SearchToolSettingsComponent_Factory(t) {
        return new (t || SearchToolSettingsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SearchToolSettingsComponent,
        selectors: [["met-search-tool-settings"]],
        outputs: {
          cancel: "cancel",
          save: "save"
        },
        decls: 33,
        vars: 0,
        consts: [[1, "pt-1"], [1, "fw-bold", "text-dark", "mb-7"], [1, "pb-4", "border-bottom"], [1, "form-check", "form-switch", "form-switch-sm", "form-check-custom", "form-check-solid", "flex-stack"], [1, "form-check-label", "text-gray-700", "fs-6", "fw-bold", "ms-0", "me-2"], ["type", "checkbox", "value", "1", "checked", "checked", 1, "form-check-input"], [1, "py-4", "border-bottom"], ["type", "checkbox", "value", "1", 1, "form-check-input"], [1, "d-flex", "justify-content-end", "pt-7"], ["type", "reset", 1, "btn", "btn-sm", "btn-light", "fw-bolder", "btn-active-light-primary", "me-2", 3, "click"], ["type", "submit", 1, "btn", "btn-sm", "fw-bolder", "btn-primary", 3, "click"]],
        template: function SearchToolSettingsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "form", 0)(1, "h3", 1);
            i0.ɵɵtext(2, "Search Preferences");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 2)(4, "label", 3)(5, "span", 4);
            i0.ɵɵtext(6, "Projects");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(7, "input", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 6)(9, "label", 3)(10, "span", 4);
            i0.ɵɵtext(11, "Targets");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(12, "input", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(13, "div", 6)(14, "label", 3)(15, "span", 4);
            i0.ɵɵtext(16, "Affiliate Programs");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(17, "input", 7);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(18, "div", 6)(19, "label", 3)(20, "span", 4);
            i0.ɵɵtext(21, "Referrals");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(22, "input", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(23, "div", 6)(24, "label", 3)(25, "span", 4);
            i0.ɵɵtext(26, "Users");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(27, "input", 7);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(28, "div", 8)(29, "button", 9);
            i0.ɵɵlistener("click", function SearchToolSettingsComponent_Template_button_click_29_listener() {
              return ctx.cancel.emit();
            });
            i0.ɵɵtext(30, " Cancel ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(31, "button", 10);
            i0.ɵɵlistener("click", function SearchToolSettingsComponent_Template_button_click_31_listener() {
              return ctx.save.emit();
            });
            i0.ɵɵtext(32, " Save Changes ");
            i0.ɵɵelementEnd()()();
          }
        },
        dependencies: [i1$2.ɵNgNoValidate, i1$2.NgControlStatusGroup]
      });
    }
  }
  return SearchToolSettingsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SearchToolAdvancedComponent = /*#__PURE__*/(() => {
  class SearchToolAdvancedComponent {
    constructor() {
      this.cancel = new EventEmitter();
      this.search = new EventEmitter();
    }
    static {
      this.ɵfac = function SearchToolAdvancedComponent_Factory(t) {
        return new (t || SearchToolAdvancedComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SearchToolAdvancedComponent,
        selectors: [["met-search-tool-advanced"]],
        outputs: {
          cancel: "cancel",
          search: "search"
        },
        decls: 65,
        vars: 0,
        consts: [[1, "pt-1"], [1, "fw-bold", "text-dark", "mb-7"], [1, "mb-5"], ["type", "text", "placeholder", "Contains the word", "name", "query", 1, "form-control", "form-control-sm", "form-control-solid"], [1, "nav-group", "nav-group-fluid"], ["type", "radio", "name", "type", "value", "has", "checked", "checked", 1, "btn-check"], [1, "btn", "btn-sm", "btn-color-muted", "btn-active", "btn-active-primary"], ["type", "radio", "name", "type", "value", "users", 1, "btn-check"], [1, "btn", "btn-sm", "btn-color-muted", "btn-active", "btn-active-primary", "px-4"], ["type", "radio", "name", "type", "value", "orders", 1, "btn-check"], ["type", "radio", "name", "type", "value", "projects", 1, "btn-check"], ["type", "text", "name", "assignedto", "placeholder", "Assigned to", "value", "", 1, "form-control", "form-control-sm", "form-control-solid"], ["type", "text", "name", "collaborators", "placeholder", "Collaborators", "value", "", 1, "form-control", "form-control-sm", "form-control-solid"], ["type", "radio", "name", "attachment", "value", "has", "checked", "checked", 1, "btn-check"], ["type", "radio", "name", "attachment", "value", "any", 1, "btn-check"], ["name", "timezone", "aria-label", "Select a Timezone", 1, "form-select", "form-select-sm", "form-select-solid"], ["value", "next"], ["value", "last"], ["value", "between"], ["value", "on"], [1, "row", "mb-8"], [1, "col-6"], ["type", "number", "name", "date_number", "placeholder", "Lenght", "value", "", 1, "form-control", "form-control-sm", "form-control-solid"], ["name", "date_typer", "aria-label", "Select a Timezone", 1, "form-select", "form-select-sm", "form-select-solid"], ["value", "days"], ["value", "weeks"], ["value", "months"], ["value", "years"], [1, "d-flex", "justify-content-end"], ["type", "reset", 1, "btn", "btn-sm", "btn-light", "fw-bolder", "btn-active-light-primary", "me-2", 3, "click"], ["href", "../../demo1/dist/pages/search/horizontal.html", 1, "btn", "btn-sm", "fw-bolder", "btn-primary", 3, "click"]],
        template: function SearchToolAdvancedComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "form", 0)(1, "h3", 1);
            i0.ɵɵtext(2, "Advanced Search");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 2);
            i0.ɵɵelement(4, "input", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 2)(6, "div", 4)(7, "label");
            i0.ɵɵelement(8, "input", 5);
            i0.ɵɵelementStart(9, "span", 6);
            i0.ɵɵtext(10, "All");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(11, "label");
            i0.ɵɵelement(12, "input", 7);
            i0.ɵɵelementStart(13, "span", 8);
            i0.ɵɵtext(14, "Users");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(15, "label");
            i0.ɵɵelement(16, "input", 9);
            i0.ɵɵelementStart(17, "span", 8);
            i0.ɵɵtext(18, "Orders");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(19, "label");
            i0.ɵɵelement(20, "input", 10);
            i0.ɵɵelementStart(21, "span", 8);
            i0.ɵɵtext(22, "Projects");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(23, "div", 2);
            i0.ɵɵelement(24, "input", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(25, "div", 2);
            i0.ɵɵelement(26, "input", 12);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(27, "div", 2)(28, "div", 4)(29, "label");
            i0.ɵɵelement(30, "input", 13);
            i0.ɵɵelementStart(31, "span", 6);
            i0.ɵɵtext(32, "Has attachment");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(33, "label");
            i0.ɵɵelement(34, "input", 14);
            i0.ɵɵelementStart(35, "span", 8);
            i0.ɵɵtext(36, "Any");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(37, "div", 2)(38, "select", 15)(39, "option", 16);
            i0.ɵɵtext(40, "Within the next");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(41, "option", 17);
            i0.ɵɵtext(42, "Within the last");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(43, "option", 18);
            i0.ɵɵtext(44, "Between");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(45, "option", 19);
            i0.ɵɵtext(46, "On");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(47, "div", 20)(48, "div", 21);
            i0.ɵɵelement(49, "input", 22);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(50, "div", 21)(51, "select", 23)(52, "option", 24);
            i0.ɵɵtext(53, "Days");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(54, "option", 25);
            i0.ɵɵtext(55, "Weeks");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(56, "option", 26);
            i0.ɵɵtext(57, "Months");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(58, "option", 27);
            i0.ɵɵtext(59, "Years");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(60, "div", 28)(61, "button", 29);
            i0.ɵɵlistener("click", function SearchToolAdvancedComponent_Template_button_click_61_listener() {
              return ctx.cancel.emit();
            });
            i0.ɵɵtext(62, " Cancel ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(63, "a", 30);
            i0.ɵɵlistener("click", function SearchToolAdvancedComponent_Template_a_click_63_listener() {
              return ctx.search.emit();
            });
            i0.ɵɵtext(64, "Search");
            i0.ɵɵelementEnd()()();
          }
        },
        dependencies: [i1$2.ɵNgNoValidate, i1$2.NgSelectOption, i1$2.ɵNgSelectMultipleOption, i1$2.NgControlStatusGroup]
      });
    }
  }
  return SearchToolAdvancedComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
let SearchToolComponent = /*#__PURE__*/(() => {
  class SearchToolComponent {
    constructor() {
      this.placement = PopperPlacements;
      this.trigger = PopperTriggers;
      this.view = 'search';
      this.searchView = 'recent';
    }
    onSaveSettings() {}
    onAdvancedSearch() {
      this.view = 'search';
    }
    static {
      this.ɵfac = function SearchToolComponent_Factory(t) {
        return new (t || SearchToolComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SearchToolComponent,
        selectors: [["met-search-tool"]],
        decls: 8,
        vars: 8,
        consts: [[1, "btn", "btn-icon", "btn-active-light-primary", "w-30px", "h-30px", "w-md-40px", "h-md-40px", 3, "metPopper", "metPopperTrigger", "metPopperHideOnClickOutside", "metPopperHideOnScroll", "metPopperPlacement"], ["src", "assets/media/metronic/icons/duotune/general/gen021.svg", 1, "svg-icon", "svg-icon-1"], ["content", ""], [1, "menu", "menu-sub", "menu-sub-dropdown", "p-7", "w-325px", "w-md-375px", "show"], [4, "ngIf"], [3, "cancel", "save", 4, "ngIf"], [3, "cancel", "search", 4, "ngIf"], ["autocomplete", "off", 1, "w-100", "position-relative", "mb-3"], ["src", "assets/media/metronic/icons/duotune/general/gen021.svg", 1, "svg-icon", "svg-icon-2", "svg-icon-lg-1", "svg-icon-gray-500", "position-absolute", "top-50", "translate-middle-y", "ms-0"], ["type", "text", "name", "search", "value", "", "placeholder", "Search...", 1, "form-control", "form-control-flush", "ps-10"], [1, "position-absolute", "top-50", "end-0", "translate-middle-y", "lh-0", "d-none", "me-1"], [1, "spinner-border", "h-15px", "w-15px", "align-middle", "text-gray-400"], [1, "btn", "btn-flush", "btn-active-color-primary", "position-absolute", "top-50", "end-0", "translate-middle-y", "lh-0", "d-none"], ["src", "assets/media/metronic/icons/duotune/arrows/arr061.svg", 1, "svg-icon", "svg-icon-2", "svg-icon-lg-1", "me-0"], [1, "position-absolute", "top-50", "end-0", "translate-middle-y"], ["title", "Show search preferences", 1, "btn", "btn-icon", "w-20px", "btn-sm", "btn-active-color-primary", "me-1", 3, "click"], ["src", "assets/media/metronic/icons/duotune/coding/cod001.svg", 1, "svg-icon", "svg-icon-1"], ["title", "Show more search options", 1, "btn", "btn-icon", "w-20px", "btn-sm", "btn-active-color-primary", 3, "click"], ["src", "assets/media/metronic/icons/duotune/arrows/arr072.svg", 1, "svg-icon", "svg-icon-2"], [1, "separator", "border-gray-200", "mb-6"], [3, "cancel", "save"], [3, "cancel", "search"]],
        template: function SearchToolComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "svg-icon", 1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "met-popper-content", null, 2)(4, "div", 3);
            i0.ɵɵtemplate(5, SearchToolComponent_div_5_Template, 17, 3, "div", 4)(6, SearchToolComponent_met_search_tool_settings_6_Template, 1, 0, "met-search-tool-settings", 5)(7, SearchToolComponent_met_search_tool_advanced_7_Template, 1, 0, "met-search-tool-advanced", 6);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            const _r0 = i0.ɵɵreference(3);
            i0.ɵɵproperty("metPopper", _r0)("metPopperTrigger", ctx.trigger.click)("metPopperHideOnClickOutside", true)("metPopperHideOnScroll", true)("metPopperPlacement", ctx.placement.BOTTOMEND);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", ctx.view === "search");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.view === "settings");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.view === "advanced");
          }
        },
        dependencies: [i1$1.NgIf, i2.SvgIconComponent, i3.PopperDirective, i3.PopperContentComponent, i1$2.ɵNgNoValidate, i1$2.NgControlStatusGroup, SearchToolResultsComponent, SearchToolRecentComponent, SearchToolEmptyComponent, SearchToolSettingsComponent, SearchToolAdvancedComponent]
      });
    }
  }
  return SearchToolComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HeaderNotificationAlertsComponent = /*#__PURE__*/(() => {
  class HeaderNotificationAlertsComponent {
    static {
      this.ɵfac = function HeaderNotificationAlertsComponent_Factory(t) {
        return new (t || HeaderNotificationAlertsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HeaderNotificationAlertsComponent,
        selectors: [["met-header-notification-alerts"]],
        decls: 117,
        vars: 0,
        consts: [[1, "scroll-y", "scroll-thin", "mh-325px", "my-5", "px-8"], [1, "d-flex", "flex-stack", "py-4"], [1, "d-flex", "align-items-center"], [1, "symbol", "symbol-35px", "me-4"], [1, "symbol-label", "bg-light-primary"], [1, "svg-icon", "svg-icon-2", "svg-icon-primary"], ["xmlns", "http://www.w3.org/2000/svg", "width", "24px", "height", "24px", "viewBox", "0 0 24 24", "version", "1.1"], ["d", "M11.2600599,5.81393408 L2,16 L22,16 L12.7399401,5.81393408 C12.3684331,5.40527646 11.7359848,5.37515988 11.3273272,5.7466668 C11.3038503,5.7680094 11.2814025,5.79045722 11.2600599,5.81393408 Z", "fill", "#000000", "opacity", "0.3"], ["d", "M12.0056789,15.7116802 L20.2805786,6.85290308 C20.6575758,6.44930487 21.2903735,6.42774054 21.6939717,6.8047378 C21.8964274,6.9938498 22.0113578,7.25847607 22.0113578,7.535517 L22.0113578,20 L16.0113578,20 L2,20 L2,7.535517 C2,7.25847607 2.11493033,6.9938498 2.31738608,6.8047378 C2.72098429,6.42774054 3.35378194,6.44930487 3.7307792,6.85290308 L12.0056789,15.7116802 Z", "fill", "#000000"], [1, "mb-0", "me-2"], ["href", "#", 1, "fs-6", "text-gray-800", "text-hover-primary", "fw-bolder"], [1, "text-gray-400", "fs-7"], [1, "badge", "badge-light", "fs-8"], [1, "symbol-label", "bg-light-danger"], [1, "svg-icon", "svg-icon-2", "svg-icon-danger"], ["d", "M11.1669899,4.49941818 L2.82535718,19.5143571 C2.557144,19.9971408 2.7310878,20.6059441 3.21387153,20.8741573 C3.36242953,20.9566895 3.52957021,21 3.69951446,21 L21.2169432,21 C21.7692279,21 22.2169432,20.5522847 22.2169432,20 C22.2169432,19.8159952 22.1661743,19.6355579 22.070225,19.47855 L12.894429,4.4636111 C12.6064401,3.99235656 11.9909517,3.84379039 11.5196972,4.13177928 C11.3723594,4.22181902 11.2508468,4.34847583 11.1669899,4.49941818 Z", "fill", "#000000", "opacity", "0.3"], ["fill", "#000000", "x", "11", "y", "9", "width", "2", "height", "7", "rx", "1"], ["fill", "#000000", "x", "11", "y", "17", "width", "2", "height", "2", "rx", "1"], [1, "symbol-label", "bg-light-warning"], [1, "svg-icon", "svg-icon-2", "svg-icon-warning"], ["d", "M18,14 C16.3431458,14 15,12.6568542 15,11 C15,9.34314575 16.3431458,8 18,8 C19.6568542,8 21,9.34314575 21,11 C21,12.6568542 19.6568542,14 18,14 Z M9,11 C6.790861,11 5,9.209139 5,7 C5,4.790861 6.790861,3 9,3 C11.209139,3 13,4.790861 13,7 C13,9.209139 11.209139,11 9,11 Z", "fill", "#000000", "fill-rule", "nonzero", "opacity", "0.3"], ["d", "M17.6011961,15.0006174 C21.0077043,15.0378534 23.7891749,16.7601418 23.9984937,20.4 C24.0069246,20.5466056 23.9984937,21 23.4559499,21 L19.6,21 C19.6,18.7490654 18.8562935,16.6718327 17.6011961,15.0006174 Z M0.00065168429,20.1992055 C0.388258525,15.4265159 4.26191235,13 8.98334134,13 C13.7712164,13 17.7048837,15.2931929 17.9979143,20.2 C18.0095879,20.3954741 17.9979143,21 17.2466999,21 C13.541124,21 8.03472472,21 0.727502227,21 C0.476712155,21 -0.0204617505,20.45918 0.00065168429,20.1992055 Z", "fill", "#000000", "fill-rule", "nonzero"], [1, "symbol-label", "bg-light-success"], [1, "svg-icon", "svg-icon-2", "svg-icon-success"], ["xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "width", "24px", "height", "24px", "viewBox", "0 0 24 24", "version", "1.1"], ["stroke", "none", "stroke-width", "1", "fill", "none", "fill-rule", "evenodd"], ["x", "0", "y", "0", "width", "24", "height", "24"], ["d", "M12.3740377,19.9389434 L18.2226499,11.1660251 C18.4524142,10.8213786 18.3592838,10.3557266 18.0146373,10.1259623 C17.8914367,10.0438285 17.7466809,10 17.5986122,10 L13,10 L13,4.47708173 C13,4.06286817 12.6642136,3.72708173 12.25,3.72708173 C11.9992351,3.72708173 11.7650616,3.85240758 11.6259623,4.06105658 L5.7773501,12.8339749 C5.54758575,13.1786214 5.64071616,13.6442734 5.98536267,13.8740377 C6.10856331,13.9561715 6.25331908,14 6.40138782,14 L11,14 L11,19.5229183 C11,19.9371318 11.3357864,20.2729183 11.75,20.2729183 C12.0007649,20.2729183 12.2349384,20.1475924 12.3740377,19.9389434 Z", "fill", "#000000"], ["d", "M3.5,3 L5,3 L5,19.5 C5,20.3284271 4.32842712,21 3.5,21 L3.5,21 C2.67157288,21 2,20.3284271 2,19.5 L2,4.5 C2,3.67157288 2.67157288,3 3.5,3 Z", "fill", "#000000"], ["d", "M6.99987583,2.99995344 L19.754647,2.99999303 C20.3069317,2.99999474 20.7546456,3.44771138 20.7546439,3.99999613 C20.7546431,4.24703684 20.6631995,4.48533385 20.497938,4.66895776 L17.5,8 L20.4979317,11.3310353 C20.8673908,11.7415453 20.8341123,12.3738351 20.4236023,12.7432941 C20.2399776,12.9085564 20.0016794,13 19.7546376,13 L6.99987583,13 L6.99987583,2.99995344 Z", "fill", "#000000", "opacity", "0.3"], [1, "symbol-label", "bg-light-info"], [1, "svg-icon", "svg-icon-2", "svg-icon-info"], ["points", "0 0 24 0 24 24 0 24"], ["d", "M6,5 L18,5 C19.6568542,5 21,6.34314575 21,8 L21,17 C21,18.6568542 19.6568542,20 18,20 L6,20 C4.34314575,20 3,18.6568542 3,17 L3,8 C3,6.34314575 4.34314575,5 6,5 Z M5,17 L14,17 L9.5,11 L5,17 Z M16,14 C17.6568542,14 19,12.6568542 19,11 C19,9.34314575 17.6568542,8 16,8 C14.3431458,8 13,9.34314575 13,11 C13,12.6568542 14.3431458,14 16,14 Z", "fill", "#000000"], ["d", "M12.7442084,3.27882877 L19.2473374,6.9949025 C19.7146999,7.26196679 20.003129,7.75898194 20.003129,8.29726722 L20.003129,15.7027328 C20.003129,16.2410181 19.7146999,16.7380332 19.2473374,17.0050975 L12.7442084,20.7211712 C12.2830594,20.9846849 11.7169406,20.9846849 11.2557916,20.7211712 L4.75266256,17.0050975 C4.28530007,16.7380332 3.99687097,16.2410181 3.99687097,15.7027328 L3.99687097,8.29726722 C3.99687097,7.75898194 4.28530007,7.26196679 4.75266256,6.9949025 L11.2557916,3.27882877 C11.7169406,3.01531506 12.2830594,3.01531506 12.7442084,3.27882877 Z M12,14.5 C13.3807119,14.5 14.5,13.3807119 14.5,12 C14.5,10.6192881 13.3807119,9.5 12,9.5 C10.6192881,9.5 9.5,10.6192881 9.5,12 C9.5,13.3807119 10.6192881,14.5 12,14.5 Z", "fill", "#000000"], [1, "py-3", "text-center", "border-top"], ["href", "../../demo1/dist/pages/profile/activity.html", 1, "btn", "btn-color-gray-600", "btn-active-color-primary"], [1, "svg-icon", "svg-icon-5"], ["fill", "#000000", "opacity", "0.5", "transform", "translate(8.500000, 12.000000) rotate(-90.000000) translate(-8.500000, -12.000000)", "x", "7.5", "y", "7.5", "width", "2", "height", "9", "rx", "1"], ["d", "M9.70710318,15.7071045 C9.31657888,16.0976288 8.68341391,16.0976288 8.29288961,15.7071045 C7.90236532,15.3165802 7.90236532,14.6834152 8.29288961,14.2928909 L14.2928896,8.29289093 C14.6714686,7.914312 15.281055,7.90106637 15.675721,8.26284357 L21.675721,13.7628436 C22.08284,14.136036 22.1103429,14.7686034 21.7371505,15.1757223 C21.3639581,15.5828413 20.7313908,15.6103443 20.3242718,15.2371519 L15.0300721,10.3841355 L9.70710318,15.7071045 Z", "fill", "#000000", "fill-rule", "nonzero", "transform", "translate(14.999999, 11.999997) scale(1, -1) rotate(90.000000) translate(-14.999999, -11.999997)"]],
        template: function HeaderNotificationAlertsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "span", 4)(5, "span", 5);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(6, "svg", 6);
            i0.ɵɵelement(7, "path", 7)(8, "path", 8);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(9, "div", 9)(10, "a", 10);
            i0.ɵɵtext(11, "Project Alice");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "div", 11);
            i0.ɵɵtext(13, "Phase 1 development");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(14, "span", 12);
            i0.ɵɵtext(15, "1 hr");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(16, "div", 1)(17, "div", 2)(18, "div", 3)(19, "span", 13)(20, "span", 14);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(21, "svg", 6);
            i0.ɵɵelement(22, "path", 15)(23, "rect", 16)(24, "rect", 17);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(25, "div", 9)(26, "a", 10);
            i0.ɵɵtext(27, "HR Confidential");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(28, "div", 11);
            i0.ɵɵtext(29, "Confidential staff documents");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(30, "span", 12);
            i0.ɵɵtext(31, "2 hrs");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(32, "div", 1)(33, "div", 2)(34, "div", 3)(35, "span", 18)(36, "span", 19);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(37, "svg", 6);
            i0.ɵɵelement(38, "path", 20)(39, "path", 21);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(40, "div", 9)(41, "a", 10);
            i0.ɵɵtext(42, "Company HR");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(43, "div", 11);
            i0.ɵɵtext(44, "Corporeate staff profiles");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(45, "span", 12);
            i0.ɵɵtext(46, "5 hrs");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(47, "div", 1)(48, "div", 2)(49, "div", 3)(50, "span", 22)(51, "span", 23);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(52, "svg", 24)(53, "g", 25);
            i0.ɵɵelement(54, "rect", 26)(55, "path", 27);
            i0.ɵɵelementEnd()()()()();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(56, "div", 9)(57, "a", 10);
            i0.ɵɵtext(58, "Project Redux");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(59, "div", 11);
            i0.ɵɵtext(60, "New frontend admin theme");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(61, "span", 12);
            i0.ɵɵtext(62, "2 days");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(63, "div", 1)(64, "div", 2)(65, "div", 3)(66, "span", 4)(67, "span", 5);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(68, "svg", 6);
            i0.ɵɵelement(69, "path", 28)(70, "path", 29);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(71, "div", 9)(72, "a", 10);
            i0.ɵɵtext(73, "Project Breafing");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(74, "div", 11);
            i0.ɵɵtext(75, "Product launch status update");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(76, "span", 12);
            i0.ɵɵtext(77, "21 Jan");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(78, "div", 1)(79, "div", 2)(80, "div", 3)(81, "span", 30)(82, "span", 31);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(83, "svg", 6)(84, "g", 25);
            i0.ɵɵelement(85, "polygon", 32)(86, "path", 33);
            i0.ɵɵelementEnd()()()()();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(87, "div", 9)(88, "a", 10);
            i0.ɵɵtext(89, "Banner Assets");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(90, "div", 11);
            i0.ɵɵtext(91, "Collection of banner images");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(92, "span", 12);
            i0.ɵɵtext(93, "21 Jan");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(94, "div", 1)(95, "div", 2)(96, "div", 3)(97, "span", 18)(98, "span", 19);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(99, "svg", 6);
            i0.ɵɵelement(100, "path", 34);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(101, "div", 9)(102, "a", 10);
            i0.ɵɵtext(103, "Icon Assets");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(104, "div", 11);
            i0.ɵɵtext(105, "Collection of SVG icons");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(106, "span", 12);
            i0.ɵɵtext(107, "20 March");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(108, "div", 35)(109, "a", 36);
            i0.ɵɵtext(110, "View All ");
            i0.ɵɵelementStart(111, "span", 37);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(112, "svg", 24)(113, "g", 25);
            i0.ɵɵelement(114, "polygon", 32)(115, "rect", 38)(116, "path", 39);
            i0.ɵɵelementEnd()()()()();
          }
        }
      });
    }
  }
  return HeaderNotificationAlertsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HeaderNotificationUpdatesComponent = /*#__PURE__*/(() => {
  class HeaderNotificationUpdatesComponent {
    static {
      this.ɵfac = function HeaderNotificationUpdatesComponent_Factory(t) {
        return new (t || HeaderNotificationUpdatesComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HeaderNotificationUpdatesComponent,
        selectors: [["met-header-notification-updates"]],
        decls: 9,
        vars: 0,
        consts: [[1, "d-flex", "flex-column", "px-9"], [1, "pt-10", "pb-0"], [1, "text-dark", "text-center", "fw-bolder"], [1, "text-center", "text-gray-600", "fw-bold", "pt-1"], [1, "text-center", "mt-5", "mb-9"], ["href", "#", 1, "btn", "btn-sm", "btn-primary", "px-6"]],
        template: function HeaderNotificationUpdatesComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h3", 2);
            i0.ɵɵtext(3, "Get Pro Access");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 3);
            i0.ɵɵtext(5, " Outlines keep you honest. They stoping you from amazing poorly about drive ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 4)(7, "a", 5);
            i0.ɵɵtext(8, "Upgrade");
            i0.ɵɵelementEnd()()()();
          }
        }
      });
    }
  }
  return HeaderNotificationUpdatesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HeaderNotificationLogsComponent = /*#__PURE__*/(() => {
  class HeaderNotificationLogsComponent {
    static {
      this.ɵfac = function HeaderNotificationLogsComponent_Factory(t) {
        return new (t || HeaderNotificationLogsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HeaderNotificationLogsComponent,
        selectors: [["met-header-notification-logs"]],
        decls: 106,
        vars: 0,
        consts: [[1, "scroll-y", "scroll-thin", "mh-325px", "my-5", "px-8"], [1, "d-flex", "flex-stack", "py-4"], [1, "d-flex", "align-items-center", "me-2"], [1, "w-70px", "badge", "badge-light-success", "me-4"], ["href", "#", 1, "text-gray-800", "text-hover-primary", "fw-bold"], [1, "badge", "badge-light", "fs-8"], [1, "w-70px", "badge", "badge-light-danger", "me-4"], [1, "w-70px", "badge", "badge-light-warning", "me-4"], [1, "py-3", "text-center", "border-top"], ["href", "../../demo1/dist/pages/profile/activity.html", 1, "btn", "btn-color-gray-600", "btn-active-color-primary"], [1, "svg-icon", "svg-icon-5"], ["xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "width", "24px", "height", "24px", "viewBox", "0 0 24 24", "version", "1.1"], ["stroke", "none", "stroke-width", "1", "fill", "none", "fill-rule", "evenodd"], ["points", "0 0 24 0 24 24 0 24"], ["fill", "#000000", "opacity", "0.5", "transform", "translate(8.500000, 12.000000) rotate(-90.000000) translate(-8.500000, -12.000000)", "x", "7.5", "y", "7.5", "width", "2", "height", "9", "rx", "1"], ["d", "M9.70710318,15.7071045 C9.31657888,16.0976288 8.68341391,16.0976288 8.29288961,15.7071045 C7.90236532,15.3165802 7.90236532,14.6834152 8.29288961,14.2928909 L14.2928896,8.29289093 C14.6714686,7.914312 15.281055,7.90106637 15.675721,8.26284357 L21.675721,13.7628436 C22.08284,14.136036 22.1103429,14.7686034 21.7371505,15.1757223 C21.3639581,15.5828413 20.7313908,15.6103443 20.3242718,15.2371519 L15.0300721,10.3841355 L9.70710318,15.7071045 Z", "fill", "#000000", "fill-rule", "nonzero", "transform", "translate(14.999999, 11.999997) scale(1, -1) rotate(90.000000) translate(-14.999999, -11.999997)"]],
        template: function HeaderNotificationLogsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "span", 3);
            i0.ɵɵtext(4, "200 OK");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "a", 4);
            i0.ɵɵtext(6, "New order");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "span", 5);
            i0.ɵɵtext(8, "Just now");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(9, "div", 1)(10, "div", 2)(11, "span", 6);
            i0.ɵɵtext(12, "500 ERR");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "a", 4);
            i0.ɵɵtext(14, "New customer");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(15, "span", 5);
            i0.ɵɵtext(16, "2 hrs");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(17, "div", 1)(18, "div", 2)(19, "span", 3);
            i0.ɵɵtext(20, "200 OK");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(21, "a", 4);
            i0.ɵɵtext(22, "Payment process");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(23, "span", 5);
            i0.ɵɵtext(24, "5 hrs");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(25, "div", 1)(26, "div", 2)(27, "span", 7);
            i0.ɵɵtext(28, "300 WRN");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(29, "a", 4);
            i0.ɵɵtext(30, "Search query");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(31, "span", 5);
            i0.ɵɵtext(32, "2 days");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(33, "div", 1)(34, "div", 2)(35, "span", 3);
            i0.ɵɵtext(36, "200 OK");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(37, "a", 4);
            i0.ɵɵtext(38, "API connection");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(39, "span", 5);
            i0.ɵɵtext(40, "1 week");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(41, "div", 1)(42, "div", 2)(43, "span", 3);
            i0.ɵɵtext(44, "200 OK");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(45, "a", 4);
            i0.ɵɵtext(46, "Database restore");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(47, "span", 5);
            i0.ɵɵtext(48, "Mar 5");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(49, "div", 1)(50, "div", 2)(51, "span", 7);
            i0.ɵɵtext(52, "300 WRN");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(53, "a", 4);
            i0.ɵɵtext(54, "System update");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(55, "span", 5);
            i0.ɵɵtext(56, "May 15");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(57, "div", 1)(58, "div", 2)(59, "span", 7);
            i0.ɵɵtext(60, "300 WRN");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(61, "a", 4);
            i0.ɵɵtext(62, "Server OS update");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(63, "span", 5);
            i0.ɵɵtext(64, "Apr 3");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(65, "div", 1)(66, "div", 2)(67, "span", 7);
            i0.ɵɵtext(68, "300 WRN");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(69, "a", 4);
            i0.ɵɵtext(70, "API rollback");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(71, "span", 5);
            i0.ɵɵtext(72, "Jun 30");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(73, "div", 1)(74, "div", 2)(75, "span", 6);
            i0.ɵɵtext(76, "500 ERR");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(77, "a", 4);
            i0.ɵɵtext(78, "Refund process");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(79, "span", 5);
            i0.ɵɵtext(80, "Jul 10");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(81, "div", 1)(82, "div", 2)(83, "span", 6);
            i0.ɵɵtext(84, "500 ERR");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(85, "a", 4);
            i0.ɵɵtext(86, "Withdrawal process");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(87, "span", 5);
            i0.ɵɵtext(88, "Sep 10");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(89, "div", 1)(90, "div", 2)(91, "span", 6);
            i0.ɵɵtext(92, "500 ERR");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(93, "a", 4);
            i0.ɵɵtext(94, "Mail tasks");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(95, "span", 5);
            i0.ɵɵtext(96, "Dec 10");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(97, "div", 8)(98, "a", 9);
            i0.ɵɵtext(99, "View All ");
            i0.ɵɵelementStart(100, "span", 10);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(101, "svg", 11)(102, "g", 12);
            i0.ɵɵelement(103, "polygon", 13)(104, "rect", 14)(105, "path", 15);
            i0.ɵɵelementEnd()()()()();
          }
        }
      });
    }
  }
  return HeaderNotificationLogsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HeaderNotificationComponent = /*#__PURE__*/(() => {
  class HeaderNotificationComponent {
    constructor() {
      this.placement = PopperPlacements;
      this.trigger = PopperTriggers;
      this.tabs = [{
        key: 'updates',
        title: 'Updates'
      }, {
        key: 'alerts',
        title: 'Alerts'
      }, {
        key: 'logs',
        title: 'Logs'
      }];
      this.activeTab = this.tabs[0];
    }
    static {
      this.ɵfac = function HeaderNotificationComponent_Factory(t) {
        return new (t || HeaderNotificationComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HeaderNotificationComponent,
        selectors: [["met-header-notification"]],
        decls: 22,
        vars: 18,
        consts: [[1, "btn", "btn-icon", "btn-active-light-primary", "position-relative", "w-30px", "h-30px", "w-md-40px", "h-md-40px", 3, "metPopper", "metPopperTrigger", "metPopperHideOnClickOutside", "metPopperHideOnScroll", "metPopperPlacement"], [1, "svg-icon", "svg-icon-1"], ["xmlns", "http://www.w3.org/2000/svg", "width", "24px", "height", "24px", "viewBox", "0 0 24 24", "version", "1.1"], ["d", "M2.56066017,10.6819805 L4.68198052,8.56066017 C5.26776695,7.97487373 6.21751442,7.97487373 6.80330086,8.56066017 L8.9246212,10.6819805 C9.51040764,11.267767 9.51040764,12.2175144 8.9246212,12.8033009 L6.80330086,14.9246212 C6.21751442,15.5104076 5.26776695,15.5104076 4.68198052,14.9246212 L2.56066017,12.8033009 C1.97487373,12.2175144 1.97487373,11.267767 2.56066017,10.6819805 Z M14.5606602,10.6819805 L16.6819805,8.56066017 C17.267767,7.97487373 18.2175144,7.97487373 18.8033009,8.56066017 L20.9246212,10.6819805 C21.5104076,11.267767 21.5104076,12.2175144 20.9246212,12.8033009 L18.8033009,14.9246212 C18.2175144,15.5104076 17.267767,15.5104076 16.6819805,14.9246212 L14.5606602,12.8033009 C13.9748737,12.2175144 13.9748737,11.267767 14.5606602,10.6819805 Z", "fill", "#000000", "opacity", "0.3"], ["d", "M8.56066017,16.6819805 L10.6819805,14.5606602 C11.267767,13.9748737 12.2175144,13.9748737 12.8033009,14.5606602 L14.9246212,16.6819805 C15.5104076,17.267767 15.5104076,18.2175144 14.9246212,18.8033009 L12.8033009,20.9246212 C12.2175144,21.5104076 11.267767,21.5104076 10.6819805,20.9246212 L8.56066017,18.8033009 C7.97487373,18.2175144 7.97487373,17.267767 8.56066017,16.6819805 Z M8.56066017,4.68198052 L10.6819805,2.56066017 C11.267767,1.97487373 12.2175144,1.97487373 12.8033009,2.56066017 L14.9246212,4.68198052 C15.5104076,5.26776695 15.5104076,6.21751442 14.9246212,6.80330086 L12.8033009,8.9246212 C12.2175144,9.51040764 11.267767,9.51040764 10.6819805,8.9246212 L8.56066017,6.80330086 C7.97487373,6.21751442 7.97487373,5.26776695 8.56066017,4.68198052 Z", "fill", "#000000"], ["content", ""], [1, "menu", "menu-sub", "menu-sub-dropdown", "menu-column", "w-350px", "w-lg-375px", 2, "display", "block"], [1, "d-flex", "flex-column", "bgi-no-repeat", "rounded-top", 2, "background-image", "url('assets/media/metronic/misc/pattern-1.jpg')"], [1, "text-white", "fw-bold", "px-9", "mt-10", "mb-6"], [1, "fs-8", "opacity-75", "ps-3"], [1, "nav", "nav-line-tabs", "nav-line-tabs-2x", "nav-stretch", "fw-bold", "px-9"], ["class", "nav-item", 4, "ngFor", "ngForOf"], [1, "tab-content"], ["role", "tabpanel", 1, "tab-pane", "fade"], [1, "nav-item"], ["href", "#", 1, "nav-link", "text-white", "opacity-75", "opacity-state-100", "pb-4", 3, "click"]],
        template: function HeaderNotificationComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "span", 1);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(2, "svg", 2);
            i0.ɵɵelement(3, "path", 3)(4, "path", 4);
            i0.ɵɵelementEnd()()();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(5, "met-popper-content", null, 5)(7, "div", 6)(8, "div", 7)(9, "h3", 8);
            i0.ɵɵtext(10, " Notifications ");
            i0.ɵɵelementStart(11, "span", 9);
            i0.ɵɵtext(12, "24 reports");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(13, "ul", 10);
            i0.ɵɵtemplate(14, HeaderNotificationComponent_li_14_Template, 3, 3, "li", 11);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(15, "div", 12)(16, "div", 13);
            i0.ɵɵelement(17, "met-header-notification-alerts");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(18, "div", 13);
            i0.ɵɵelement(19, "met-header-notification-updates");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(20, "div", 13);
            i0.ɵɵelement(21, "met-header-notification-logs");
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            const _r0 = i0.ɵɵreference(6);
            i0.ɵɵproperty("metPopper", _r0)("metPopperTrigger", ctx.trigger.click)("metPopperHideOnClickOutside", true)("metPopperHideOnScroll", true)("metPopperPlacement", ctx.placement.BOTTOMEND);
            i0.ɵɵadvance(14);
            i0.ɵɵproperty("ngForOf", ctx.tabs);
            i0.ɵɵadvance(2);
            i0.ɵɵclassProp("active", ctx.activeTab.key === "alerts")("show", ctx.activeTab.key === "alerts");
            i0.ɵɵadvance(2);
            i0.ɵɵclassProp("active", ctx.activeTab.key === "updates")("show", ctx.activeTab.key === "updates");
            i0.ɵɵadvance(2);
            i0.ɵɵclassProp("active", ctx.activeTab.key === "logs")("show", ctx.activeTab.key === "logs");
          }
        },
        dependencies: [i1$1.NgForOf, i3.PopperDirective, i3.PopperContentComponent, HeaderNotificationAlertsComponent, HeaderNotificationUpdatesComponent, HeaderNotificationLogsComponent]
      });
    }
  }
  return HeaderNotificationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var Theme = /*#__PURE__*/function (Theme) {
  Theme["AUTO"] = "auto";
  Theme["LIGHT"] = "light";
  Theme["DARK"] = "dark";
  return Theme;
}(Theme || {});
let BaseLayoutService = /*#__PURE__*/(() => {
  class BaseLayoutService {
    constructor() {
      this.theme$ = new BehaviorSubject(Theme.AUTO);
      this.availableStyles = ['app-default', 'app-blank'];
      this.style = 'app-default';
      this.layout = 'dark-sidebar';
      this.headerFixed = true;
      this.headerFixedMobile = true;
      this.sidebarEnabled = true;
      this.sidebarFixed = true;
      this.sidebarHoverable = true;
      this.sidebarPushHeader = true;
      this.sidebarPushToolbar = true;
      this.sidebarPushFooter = true;
      this.toolbarEnabled = true;
      this.asideFixed = false;
      this.asideEnabled = false;
      this.sidebarMinimize = true;
      this.document = inject(DOCUMENT);
      this.platformId = inject(PLATFORM_ID);
    }
    update() {
      const theme = this.theme$.value;
      if (isPlatformBrowser(this.platformId)) {
        updateTheme();
      } else {
        this.document.getElementsByTagName('html')[0].setAttribute('data-theme', theme === Theme.AUTO ? 'light' : theme);
      }
      const classList = this.document.body.classList;
      this.availableStyles.forEach(style => {
        classList.toggle(style, this.style === style);
      });
      classList.toggle('aside-enabled', this.asideEnabled);
      classList.toggle('aside-fixed', this.asideFixed);
      const attributes = [['layout', this.layout], ['header-fixed', this.headerFixed], ['header-fixed-mobile', this.headerFixedMobile], ['sidebar-enabled', this.sidebarEnabled], ['sidebar-fixed', this.sidebarFixed], ['sidebar-hoverable', this.sidebarHoverable], ['sidebar-push-header', this.sidebarPushHeader], ['sidebar-push-toolbar', this.sidebarPushToolbar], ['sidebar-push-footer', this.sidebarPushFooter], ['toolbar-enabled', this.toolbarEnabled], ['sidebar-minimize', this.sidebarMinimize ? 'on' : false]];
      attributes.forEach(([key, value]) => {
        const attribute = 'data-kt-app-' + key;
        if (!value) {
          this.document.body.removeAttribute(attribute);
        } else {
          this.document.body.setAttribute(attribute, value);
        }
      });
    }
    static {
      this.ɵfac = function BaseLayoutService_Factory(t) {
        return new (t || BaseLayoutService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BaseLayoutService,
        factory: BaseLayoutService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return BaseLayoutService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HeaderUserComponent = /*#__PURE__*/(() => {
  class HeaderUserComponent {
    get avatar() {
      return this._avatar;
    }
    set avatar(url) {
      this._avatar = url ?? 'assets/media/metronic/avatars/blank.png';
    }
    constructor(layoutService) {
      this.layoutService = layoutService;
      this.placement = PopperPlacements;
      this.trigger = PopperTriggers;
      this.darkModeControl = new FormControl();
      this.subs = [];
      this._avatar = '';
      this.menu = [];
      this.name = '';
      this.subtitle = '';
      this.badge = null;
      this.menuItemClick = new EventEmitter();
    }
    ngOnInit() {
      let needUpdate = true;
      this.subs.push(this.layoutService.theme$.subscribe(v => {
        if (needUpdate) {
          this.darkModeControl.patchValue(v === Theme.DARK);
        }
      }), this.darkModeControl.valueChanges.subscribe(v => {
        needUpdate = false;
        this.layoutService.theme$.next(v ? Theme.DARK : Theme.LIGHT);
        needUpdate = true;
      }));
    }
    ngOnDestroy() {
      for (const sub of this.subs) {
        sub.unsubscribe();
      }
    }
    onMenuItemClick(item) {
      this.menuItemClick.next(item);
    }
    static {
      this.ɵfac = function HeaderUserComponent_Factory(t) {
        return new (t || HeaderUserComponent)(i0.ɵɵdirectiveInject(BaseLayoutService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HeaderUserComponent,
        selectors: [["met-header-user"]],
        inputs: {
          menu: "menu",
          avatar: "avatar",
          name: "name",
          subtitle: "subtitle",
          badge: "badge"
        },
        outputs: {
          menuItemClick: "menuItemClick"
        },
        decls: 24,
        vars: 12,
        consts: [[1, "cursor-pointer", "symbol", "symbol-30px", "symbol-md-40px", 3, "metPopper", "metPopperTrigger", "metPopperHideOnClickOutside", "metPopperHideOnScroll", "metPopperPlacement"], ["alt", "avatar", 3, "src"], ["content", ""], [1, "menu", "menu-sub", "menu-sub-dropdown", "menu-column", "menu-rounded", "menu-gray-800", "menu-state-bg", "menu-state-primary", "fw-bold", "py-4", "fs-6", "w-275px", 2, "display", "block"], [1, "menu-item", "px-3"], [1, "menu-content", "d-flex", "align-items-center", "px-3"], [1, "symbol", "symbol-50px", "me-5"], [1, "d-flex", "flex-column"], [1, "fw-bolder", "d-flex", "align-items-center", "fs-5"], ["class", "badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2", 4, "ngIf"], ["href", "#", 1, "fw-bold", "text-muted", "text-hover-primary", "fs-7"], [1, "separator", "my-2"], ["class", "menu-item px-5", 4, "ngFor", "ngForOf"], [1, "menu-item", "px-5"], [1, "menu-content", "px-5"], ["for", "dark-mode-toggle", 1, "form-check", "form-switch", "form-check-custom", "form-check-solid", "pulse", "pulse-success"], ["id", "dark-mode-toggle", "type", "checkbox", "value", "1", 1, "form-check-input", "w-30px", "h-20px", 3, "formControl"], [1, "form-check-label", "text-gray-600", "fs-7"], [1, "badge", "badge-light-success", "fw-bolder", "fs-8", "px-2", "py-1", "ms-2"], [1, "menu-link", "px-5", 3, "click"]],
        template: function HeaderUserComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "img", 1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "met-popper-content", null, 2)(4, "div", 3)(5, "div", 4)(6, "div", 5)(7, "div", 6);
            i0.ɵɵelement(8, "img", 1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "div", 7)(10, "div", 8);
            i0.ɵɵtext(11);
            i0.ɵɵtemplate(12, HeaderUserComponent_span_12_Template, 2, 1, "span", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "a", 10);
            i0.ɵɵtext(14);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelement(15, "div", 11);
            i0.ɵɵtemplate(16, HeaderUserComponent_div_16_Template, 3, 1, "div", 12);
            i0.ɵɵelement(17, "div", 11);
            i0.ɵɵelementStart(18, "div", 13)(19, "div", 14)(20, "label", 15);
            i0.ɵɵelement(21, "input", 16);
            i0.ɵɵelementStart(22, "span", 17);
            i0.ɵɵtext(23, "Nakties r\u0117\u017Eimas");
            i0.ɵɵelementEnd()()()()()();
          }
          if (rf & 2) {
            const _r0 = i0.ɵɵreference(3);
            i0.ɵɵproperty("metPopper", _r0)("metPopperTrigger", ctx.trigger.click)("metPopperHideOnClickOutside", true)("metPopperHideOnScroll", true)("metPopperPlacement", ctx.placement.BOTTOMEND);
            i0.ɵɵadvance();
            i0.ɵɵproperty("src", ctx.avatar, i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("src", ctx.avatar, i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx.name, " ");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.badge);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.subtitle);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.menu);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("formControl", ctx.darkModeControl);
          }
        },
        dependencies: [i1$1.NgForOf, i1$1.NgIf, i3.PopperDirective, i3.PopperContentComponent, i1$2.CheckboxControlValueAccessor, i1$2.NgControlStatus, i1$2.FormControlDirective]
      });
    }
  }
  return HeaderUserComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ContentToolbarComponent = /*#__PURE__*/(() => {
  class ContentToolbarComponent {
    constructor() {
      this.class = 'app-toolbar py-3 py-lg-6';
    }
    static {
      this.ɵfac = function ContentToolbarComponent_Factory(t) {
        return new (t || ContentToolbarComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ContentToolbarComponent,
        selectors: [["met-content-toolbar"]],
        hostVars: 2,
        hostBindings: function ContentToolbarComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.class);
          }
        },
        decls: 62,
        vars: 0,
        consts: [[1, "container-fluid", "d-flex", "flex-stack"], [1, "page-title", "d-flex", "align-items-center", "flex-wrap", "me-3", "mb-5", "mb-lg-0"], [1, "d-flex", "align-items-center", "text-dark", "fw-bolder", "my-1", "fs-3"], [1, "h-20px", "border-gray-200", "border-start", "ms-3", "mx-2"], [1, "text-muted", "fs-7", "fw-bold", "my-1", "ms-1"], [1, "d-flex", "align-items-center", "py-1"], [1, "me-4"], ["href", "#", 1, "btn", "btn-sm", "btn-flex", "btn-light", "btn-active-primary", "fw-bolder"], [1, "svg-icon", "svg-icon-5", "svg-icon-gray-500", "me-1"], ["xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "width", "24px", "height", "24px", "viewBox", "0 0 24 24", "version", "1.1"], ["stroke", "none", "stroke-width", "1", "fill", "none", "fill-rule", "evenodd"], ["x", "0", "y", "0", "width", "24", "height", "24"], ["d", "M5,4 L19,4 C19.2761424,4 19.5,4.22385763 19.5,4.5 C19.5,4.60818511 19.4649111,4.71345191 19.4,4.8 L14,12 L14,20.190983 C14,20.4671254 13.7761424,20.690983 13.5,20.690983 C13.4223775,20.690983 13.3458209,20.6729105 13.2763932,20.6381966 L10,19 L10,12 L4.6,4.8 C4.43431458,4.5790861 4.4790861,4.26568542 4.7,4.1 C4.78654809,4.03508894 4.89181489,4 5,4 Z", "fill", "#000000"], [1, "menu", "menu-sub", "menu-sub-dropdown", "w-250px", "w-md-300px"], [1, "px-7", "py-5"], [1, "fs-5", "text-dark", "fw-bolder"], [1, "separator", "border-gray-200"], [1, "mb-10"], [1, "form-label", "fw-bold"], [1, "form-select", "form-select-solid"], ["value", "1"], ["value", "2"], [1, "d-flex"], [1, "form-check", "form-check-sm", "form-check-custom", "form-check-solid", "me-5"], ["type", "checkbox", "value", "1", 1, "form-check-input"], [1, "form-check-label"], [1, "form-check", "form-check-sm", "form-check-custom", "form-check-solid"], ["type", "checkbox", "value", "2", "checked", "checked", 1, "form-check-input"], [1, "form-check", "form-switch", "form-switch-sm", "form-check-custom", "form-check-solid"], ["type", "checkbox", "value", "", "name", "notifications", "checked", "checked", 1, "form-check-input"], [1, "d-flex", "justify-content-end"], ["type", "reset", 1, "btn", "btn-sm", "btn-light", "btn-active-light-primary", "me-2"], ["type", "submit", 1, "btn", "btn-sm", "btn-primary"], ["href", "#", 1, "btn", "btn-sm", "btn-primary"]],
        template: function ContentToolbarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h1", 2);
            i0.ɵɵtext(3, " Dashboard ");
            i0.ɵɵelement(4, "span", 3);
            i0.ɵɵelementStart(5, "small", 4);
            i0.ɵɵtext(6, "#XRS-45670");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(7, "div", 5)(8, "div", 6)(9, "a", 7)(10, "span", 8);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(11, "svg", 9)(12, "g", 10);
            i0.ɵɵelement(13, "rect", 11)(14, "path", 12);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtext(15, "Filter");
            i0.ɵɵelementEnd();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(16, "div", 13)(17, "div", 14)(18, "div", 15);
            i0.ɵɵtext(19, "Filter Options");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(20, "div", 16);
            i0.ɵɵelementStart(21, "div", 14)(22, "div", 17)(23, "label", 18);
            i0.ɵɵtext(24, "Status:");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(25, "div")(26, "select", 19);
            i0.ɵɵelement(27, "option");
            i0.ɵɵelementStart(28, "option", 20);
            i0.ɵɵtext(29, "Approved");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(30, "option", 21);
            i0.ɵɵtext(31, "Pending");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(32, "option", 21);
            i0.ɵɵtext(33, "In Process");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(34, "option", 21);
            i0.ɵɵtext(35, "Rejected");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(36, "div", 17)(37, "label", 18);
            i0.ɵɵtext(38, "Member Type:");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(39, "div", 22)(40, "label", 23);
            i0.ɵɵelement(41, "input", 24);
            i0.ɵɵelementStart(42, "span", 25);
            i0.ɵɵtext(43, "Author");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(44, "label", 26);
            i0.ɵɵelement(45, "input", 27);
            i0.ɵɵelementStart(46, "span", 25);
            i0.ɵɵtext(47, "Customer");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(48, "div", 17)(49, "label", 18);
            i0.ɵɵtext(50, "Notifications:");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(51, "div", 28);
            i0.ɵɵelement(52, "input", 29);
            i0.ɵɵelementStart(53, "label", 25);
            i0.ɵɵtext(54, "Enabled");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(55, "div", 30)(56, "button", 31);
            i0.ɵɵtext(57, " Reset ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(58, "button", 32);
            i0.ɵɵtext(59, "Apply");
            i0.ɵɵelementEnd()()()()();
            i0.ɵɵelementStart(60, "a", 33);
            i0.ɵɵtext(61, "Create");
            i0.ɵɵelementEnd()()();
          }
        },
        dependencies: [i1$2.NgSelectOption, i1$2.ɵNgSelectMultipleOption]
      });
    }
  }
  return ContentToolbarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FooterComponent = /*#__PURE__*/(() => {
  class FooterComponent {
    constructor() {
      this.menu = [];
      this.defaultActiveOptions = {
        exact: false
      };
      this.class = true;
      this.date = new Date();
    }
    static {
      this.ɵfac = function FooterComponent_Factory(t) {
        return new (t || FooterComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FooterComponent,
        selectors: [["met-footer"]],
        hostVars: 2,
        hostBindings: function FooterComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("footer", ctx.class);
          }
        },
        inputs: {
          menu: "menu",
          defaultActiveOptions: "defaultActiveOptions",
          copyright: "copyright"
        },
        ngContentSelectors: _c1,
        decls: 4,
        vars: 2,
        consts: [[1, "app-container", "container-fluid", "d-flex", "flex-column", "flex-md-row", "flex-center", "flex-md-stack", "py-3"], ["class", "text-dark order-2 order-md-1", 4, "ngIf"], ["class", "menu menu-gray-600 menu-hover-primary fw-semibold order-1", 4, "ngIf"], [1, "text-dark", "order-2", "order-md-1"], [1, "text-muted", "fw-semibold", "me-1"], ["target", "_blank", 1, "text-gray-800", "text-hover-primary", 3, "href"], [1, "menu", "menu-gray-600", "menu-hover-primary", "fw-semibold", "order-1"], ["class", "menu-item", 4, "ngFor", "ngForOf"], [1, "menu-item"], ["class", "menu-link px-2", 3, "href", "target", 4, "ngIf"], ["class", "menu-link px-2", "routerLinkActive", "here", 3, "target", "routerLink", "routerLinkActiveOptions", "click", 4, "ngIf"], [1, "menu-link", "px-2", 3, "href", "target"], ["routerLinkActive", "here", 1, "menu-link", "px-2", 3, "target", "routerLink", "routerLinkActiveOptions", "click"]],
        template: function FooterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, FooterComponent_div_1_Template, 6, 6, "div", 1);
            i0.ɵɵprojection(2);
            i0.ɵɵtemplate(3, FooterComponent_ul_3_Template, 2, 1, "ul", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.copyright);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.menu.length > 0);
          }
        },
        dependencies: [i1$1.NgForOf, i1$1.NgIf, i1.RouterLink, i1.RouterLinkActive, i1$1.DatePipe]
      });
    }
  }
  return FooterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ContentComponent = /*#__PURE__*/(() => {
  class ContentComponent {
    constructor() {
      this.class = 'd-flex flex-column flex-column-fluid';
    }
    static {
      this.ɵfac = function ContentComponent_Factory(t) {
        return new (t || ContentComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ContentComponent,
        selectors: [["met-content"]],
        hostVars: 2,
        hostBindings: function ContentComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.class);
          }
        },
        ngContentSelectors: _c6,
        decls: 12,
        vars: 0,
        consts: [[1, "app-toolbar", "py-3", "py-lg-6"], [1, "app-container", "container-fluid", "d-flex", "flex-stack"], [1, "page-title", "d-flex", "flex-column", "justify-content-center", "flex-wrap", "me-3"], [1, "page-heading", "d-flex", "text-dark", "fw-bold", "fs-3", "flex-column", "justify-content-center", "my-0"], [1, "text-muted", "fw-semibold", "fs-7", "my-0", "pt-1"], [1, "d-flex", "align-items-center", "gap-2", "gap-lg-3"], [1, "app-content", "flex-column-fluid"], [1, "app-container", "container-fluid"]],
        template: function ContentComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c5);
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "h1", 3);
            i0.ɵɵprojection(4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "small", 4);
            i0.ɵɵprojection(6, 1);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "div", 5);
            i0.ɵɵprojection(8, 2);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(9, "div", 6)(10, "div", 7);
            i0.ɵɵprojection(11, 3);
            i0.ɵɵelementEnd()();
          }
        }
      });
    }
  }
  return ContentComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const components = [SideMenuComponent, MenuItemComponent, SubMenuComponent, AsideComponent, TopMenuComponent, SearchToolComponent, SearchToolResultsComponent, SearchToolRecentComponent, SearchToolEmptyComponent, SearchToolSettingsComponent, SearchToolAdvancedComponent, HeaderNotificationComponent, HeaderNotificationAlertsComponent, HeaderNotificationUpdatesComponent, HeaderNotificationLogsComponent, HeaderUserComponent, ContentToolbarComponent, FooterComponent, ContentComponent];
let BaseLayoutModule = /*#__PURE__*/(() => {
  class BaseLayoutModule {
    static {
      this.ɵfac = function BaseLayoutModule_Factory(t) {
        return new (t || BaseLayoutModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: BaseLayoutModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [BaseLayoutService],
        imports: [CommonModule, AngularSvgIconModule, PopperModule, RouterModule, ReactiveFormsModule]
      });
    }
  }
  return BaseLayoutModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NavbarComponent = /*#__PURE__*/(() => {
  class NavbarComponent {
    static {
      this.ɵfac = function NavbarComponent_Factory(t) {
        return new (t || NavbarComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NavbarComponent,
        selectors: [["met-navbar"]],
        decls: 0,
        vars: 0,
        template: function NavbarComponent_Template(rf, ctx) {}
      });
    }
  }
  return NavbarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AsideComponent, BaseLayoutModule, BaseLayoutService, ContentComponent, ContentToolbarComponent, FooterComponent, HeaderNotificationAlertsComponent, HeaderNotificationComponent, HeaderNotificationLogsComponent, HeaderNotificationUpdatesComponent, HeaderUserComponent, MenuItemComponent, NavbarComponent, SearchToolAdvancedComponent, SearchToolComponent, SearchToolEmptyComponent, SearchToolRecentComponent, SearchToolResultsComponent, SearchToolSettingsComponent, SideMenuComponent, SubMenuComponent, Theme, TopMenuComponent };
